var cov_aer4v9vw8 = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/program/programCtrl.js',
      hash = 'a0527a98e292dd8a428372278ddc1e90783ec038',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/program/programCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 6,
          column: 15
        },
        end: {
          line: 6,
          column: 26
        }
      },
      '1': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 10,
          column: 4
        }
      },
      '2': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 35
        }
      },
      '3': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 24
        }
      },
      '4': {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 4
        }
      },
      '5': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 40
        }
      },
      '6': {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 725,
          column: 3
        }
      },
      '7': {
        start: {
          line: 16,
          column: 15
        },
        end: {
          line: 16,
          column: 26
        }
      },
      '8': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 52
        }
      },
      '9': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 21,
          column: 5
        }
      },
      '10': {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 49
        }
      },
      '11': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 37
        }
      },
      '12': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 35
        }
      },
      '13': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 26,
          column: 4
        }
      },
      '14': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 48
        }
      },
      '15': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      '16': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 114
        }
      },
      '17': {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 28
        }
      },
      '18': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 27
        }
      },
      '19': {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 25
        }
      },
      '20': {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 39,
          column: 5
        }
      },
      '21': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 33
        }
      },
      '22': {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      },
      '23': {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 51,
          column: 4
        }
      },
      '24': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 174
        }
      },
      '25': {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      '26': {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 47,
          column: 75
        }
      },
      '27': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 21
        }
      },
      '28': {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 87
        }
      },
      '29': {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 70,
          column: 4
        }
      },
      '30': {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 80,
          column: 5
        }
      },
      '31': {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      '32': {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 15
        }
      },
      '33': {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      '34': {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 16
        }
      },
      '35': {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 13
        }
      },
      '36': {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      '37': {
        start: {
          line: 92,
          column: 2
        },
        end: {
          line: 94,
          column: 4
        }
      },
      '38': {
        start: {
          line: 95,
          column: 2
        },
        end: {
          line: 95,
          column: 27
        }
      },
      '39': {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 96,
          column: 31
        }
      },
      '40': {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 101,
          column: 4
        }
      },
      '41': {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 215,
          column: 4
        }
      },
      '42': {
        start: {
          line: 104,
          column: 17
        },
        end: {
          line: 104,
          column: 31
        }
      },
      '43': {
        start: {
          line: 106,
          column: 24
        },
        end: {
          line: 106,
          column: 64
        }
      },
      '44': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 28
        }
      },
      '45': {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 214,
          column: 7
        }
      },
      '46': {
        start: {
          line: 109,
          column: 17
        },
        end: {
          line: 109,
          column: 52
        }
      },
      '47': {
        start: {
          line: 110,
          column: 19
        },
        end: {
          line: 110,
          column: 33
        }
      },
      '48': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 43
        }
      },
      '49': {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 212,
          column: 7
        }
      },
      '50': {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 170,
          column: 10
        }
      },
      '51': {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 172,
          column: 76
        }
      },
      '52': {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 173,
          column: 66
        }
      },
      '53': {
        start: {
          line: 174,
          column: 8
        },
        end: {
          line: 174,
          column: 36
        }
      },
      '54': {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 63
        }
      },
      '55': {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 83
        }
      },
      '56': {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 51
        }
      },
      '57': {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 43
        }
      },
      '58': {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 35
        }
      },
      '59': {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 180,
          column: 41
        }
      },
      '60': {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 47
        }
      },
      '61': {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 183,
          column: 70
        }
      },
      '62': {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 66
        }
      },
      '63': {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 185,
          column: 71
        }
      },
      '64': {
        start: {
          line: 187,
          column: 22
        },
        end: {
          line: 187,
          column: 65
        }
      },
      '65': {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 26
        }
      },
      '66': {
        start: {
          line: 189,
          column: 8
        },
        end: {
          line: 191,
          column: 9
        }
      },
      '67': {
        start: {
          line: 190,
          column: 10
        },
        end: {
          line: 190,
          column: 84
        }
      },
      '68': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 194,
          column: 9
        }
      },
      '69': {
        start: {
          line: 193,
          column: 10
        },
        end: {
          line: 193,
          column: 28
        }
      },
      '70': {
        start: {
          line: 195,
          column: 8
        },
        end: {
          line: 195,
          column: 58
        }
      },
      '71': {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 88
        }
      },
      '72': {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 211,
          column: 10
        }
      },
      '73': {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 213,
          column: 24
        }
      },
      '74': {
        start: {
          line: 217,
          column: 2
        },
        end: {
          line: 217,
          column: 27
        }
      },
      '75': {
        start: {
          line: 218,
          column: 2
        },
        end: {
          line: 220,
          column: 4
        }
      },
      '76': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 30
        }
      },
      '77': {
        start: {
          line: 221,
          column: 2
        },
        end: {
          line: 323,
          column: 4
        }
      },
      '78': {
        start: {
          line: 222,
          column: 25
        },
        end: {
          line: 222,
          column: 58
        }
      },
      '79': {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 223,
          column: 104
        }
      },
      '80': {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 104
        }
      },
      '81': {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 96
        }
      },
      '82': {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 66
        }
      },
      '83': {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 31
        }
      },
      '84': {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 84
        }
      },
      '85': {
        start: {
          line: 228,
          column: 74
        },
        end: {
          line: 228,
          column: 82
        }
      },
      '86': {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 113
        }
      },
      '87': {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 230,
          column: 56
        }
      },
      '88': {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 231,
          column: 71
        }
      },
      '89': {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 232,
          column: 79
        }
      },
      '90': {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 233,
          column: 126
        }
      },
      '91': {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 234,
          column: 73
        }
      },
      '92': {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 85
        }
      },
      '93': {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 105
        }
      },
      '94': {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 73
        }
      },
      '95': {
        start: {
          line: 239,
          column: 4
        },
        end: {
          line: 239,
          column: 65
        }
      },
      '96': {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 240,
          column: 57
        }
      },
      '97': {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 241,
          column: 63
        }
      },
      '98': {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 69
        }
      },
      '99': {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 69
        }
      },
      '100': {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 245,
          column: 63
        }
      },
      '101': {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 246,
          column: 37
        }
      },
      '102': {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 31
        }
      },
      '103': {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 68
        }
      },
      '104': {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 249,
          column: 78
        }
      },
      '105': {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 262,
          column: 6
        }
      },
      '106': {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 266,
          column: 6
        }
      },
      '107': {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 281,
          column: 5
        }
      },
      '108': {
        start: {
          line: 269,
          column: 19
        },
        end: {
          line: 269,
          column: 41
        }
      },
      '109': {
        start: {
          line: 270,
          column: 6
        },
        end: {
          line: 280,
          column: 7
        }
      },
      '110': {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 279,
          column: 9
        }
      },
      '111': {
        start: {
          line: 273,
          column: 10
        },
        end: {
          line: 276,
          column: 12
        }
      },
      '112': {
        start: {
          line: 277,
          column: 10
        },
        end: {
          line: 277,
          column: 30
        }
      },
      '113': {
        start: {
          line: 278,
          column: 10
        },
        end: {
          line: 278,
          column: 17
        }
      },
      '114': {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 289,
          column: 5
        }
      },
      '115': {
        start: {
          line: 283,
          column: 6
        },
        end: {
          line: 286,
          column: 8
        }
      },
      '116': {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 287,
          column: 26
        }
      },
      '117': {
        start: {
          line: 288,
          column: 6
        },
        end: {
          line: 288,
          column: 13
        }
      },
      '118': {
        start: {
          line: 290,
          column: 4
        },
        end: {
          line: 297,
          column: 5
        }
      },
      '119': {
        start: {
          line: 291,
          column: 6
        },
        end: {
          line: 294,
          column: 8
        }
      },
      '120': {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 295,
          column: 26
        }
      },
      '121': {
        start: {
          line: 296,
          column: 6
        },
        end: {
          line: 296,
          column: 13
        }
      },
      '122': {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 33
        }
      },
      '123': {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 38
        }
      },
      '124': {
        start: {
          line: 302,
          column: 4
        },
        end: {
          line: 321,
          column: 5
        }
      },
      '125': {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 318,
          column: 9
        }
      },
      '126': {
        start: {
          line: 314,
          column: 8
        },
        end: {
          line: 316,
          column: 9
        }
      },
      '127': {
        start: {
          line: 315,
          column: 10
        },
        end: {
          line: 315,
          column: 17
        }
      },
      '128': {
        start: {
          line: 317,
          column: 8
        },
        end: {
          line: 317,
          column: 43
        }
      },
      '129': {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 320,
          column: 41
        }
      },
      '130': {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 322,
          column: 32
        }
      },
      '131': {
        start: {
          line: 325,
          column: 2
        },
        end: {
          line: 342,
          column: 5
        }
      },
      '132': {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 341,
          column: 5
        }
      },
      '133': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 340,
          column: 9
        }
      },
      '134': {
        start: {
          line: 337,
          column: 8
        },
        end: {
          line: 339,
          column: 9
        }
      },
      '135': {
        start: {
          line: 338,
          column: 10
        },
        end: {
          line: 338,
          column: 17
        }
      },
      '136': {
        start: {
          line: 344,
          column: 2
        },
        end: {
          line: 355,
          column: 5
        }
      },
      '137': {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 354,
          column: 6
        }
      },
      '138': {
        start: {
          line: 352,
          column: 8
        },
        end: {
          line: 352,
          column: 20
        }
      },
      '139': {
        start: {
          line: 356,
          column: 2
        },
        end: {
          line: 395,
          column: 4
        }
      },
      '140': {
        start: {
          line: 357,
          column: 19
        },
        end: {
          line: 357,
          column: 51
        }
      },
      '141': {
        start: {
          line: 358,
          column: 4
        },
        end: {
          line: 358,
          column: 28
        }
      },
      '142': {
        start: {
          line: 359,
          column: 4
        },
        end: {
          line: 394,
          column: 7
        }
      },
      '143': {
        start: {
          line: 360,
          column: 19
        },
        end: {
          line: 360,
          column: 39
        }
      },
      '144': {
        start: {
          line: 361,
          column: 6
        },
        end: {
          line: 384,
          column: 7
        }
      },
      '145': {
        start: {
          line: 362,
          column: 8
        },
        end: {
          line: 364,
          column: 9
        }
      },
      '146': {
        start: {
          line: 363,
          column: 10
        },
        end: {
          line: 363,
          column: 115
        }
      },
      '147': {
        start: {
          line: 365,
          column: 8
        },
        end: {
          line: 367,
          column: 9
        }
      },
      '148': {
        start: {
          line: 366,
          column: 10
        },
        end: {
          line: 366,
          column: 57
        }
      },
      '149': {
        start: {
          line: 368,
          column: 8
        },
        end: {
          line: 372,
          column: 9
        }
      },
      '150': {
        start: {
          line: 369,
          column: 10
        },
        end: {
          line: 369,
          column: 37
        }
      },
      '151': {
        start: {
          line: 370,
          column: 10
        },
        end: {
          line: 370,
          column: 56
        }
      },
      '152': {
        start: {
          line: 371,
          column: 10
        },
        end: {
          line: 371,
          column: 93
        }
      },
      '153': {
        start: {
          line: 373,
          column: 8
        },
        end: {
          line: 383,
          column: 9
        }
      },
      '154': {
        start: {
          line: 374,
          column: 10
        },
        end: {
          line: 382,
          column: 13
        }
      },
      '155': {
        start: {
          line: 379,
          column: 12
        },
        end: {
          line: 381,
          column: 13
        }
      },
      '156': {
        start: {
          line: 380,
          column: 14
        },
        end: {
          line: 380,
          column: 21
        }
      },
      '157': {
        start: {
          line: 387,
          column: 6
        },
        end: {
          line: 391,
          column: 7
        }
      },
      '158': {
        start: {
          line: 388,
          column: 8
        },
        end: {
          line: 390,
          column: 11
        }
      },
      '159': {
        start: {
          line: 393,
          column: 6
        },
        end: {
          line: 393,
          column: 34
        }
      },
      '160': {
        start: {
          line: 397,
          column: 2
        },
        end: {
          line: 484,
          column: 4
        }
      },
      '161': {
        start: {
          line: 398,
          column: 4
        },
        end: {
          line: 398,
          column: 29
        }
      },
      '162': {
        start: {
          line: 399,
          column: 4
        },
        end: {
          line: 399,
          column: 47
        }
      },
      '163': {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 400,
          column: 29
        }
      },
      '164': {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 401,
          column: 24
        }
      },
      '165': {
        start: {
          line: 402,
          column: 4
        },
        end: {
          line: 402,
          column: 30
        }
      },
      '166': {
        start: {
          line: 403,
          column: 4
        },
        end: {
          line: 403,
          column: 30
        }
      },
      '167': {
        start: {
          line: 404,
          column: 4
        },
        end: {
          line: 404,
          column: 24
        }
      },
      '168': {
        start: {
          line: 405,
          column: 4
        },
        end: {
          line: 405,
          column: 45
        }
      },
      '169': {
        start: {
          line: 406,
          column: 4
        },
        end: {
          line: 406,
          column: 128
        }
      },
      '170': {
        start: {
          line: 407,
          column: 4
        },
        end: {
          line: 407,
          column: 118
        }
      },
      '171': {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 417,
          column: 5
        }
      },
      '172': {
        start: {
          line: 410,
          column: 6
        },
        end: {
          line: 412,
          column: 9
        }
      },
      '173': {
        start: {
          line: 411,
          column: 8
        },
        end: {
          line: 411,
          column: 45
        }
      },
      '174': {
        start: {
          line: 414,
          column: 6
        },
        end: {
          line: 416,
          column: 7
        }
      },
      '175': {
        start: {
          line: 415,
          column: 8
        },
        end: {
          line: 415,
          column: 109
        }
      },
      '176': {
        start: {
          line: 419,
          column: 4
        },
        end: {
          line: 419,
          column: 60
        }
      },
      '177': {
        start: {
          line: 420,
          column: 4
        },
        end: {
          line: 420,
          column: 64
        }
      },
      '178': {
        start: {
          line: 421,
          column: 4
        },
        end: {
          line: 421,
          column: 68
        }
      },
      '179': {
        start: {
          line: 425,
          column: 4
        },
        end: {
          line: 425,
          column: 130
        }
      },
      '180': {
        start: {
          line: 426,
          column: 4
        },
        end: {
          line: 426,
          column: 62
        }
      },
      '181': {
        start: {
          line: 427,
          column: 4
        },
        end: {
          line: 427,
          column: 70
        }
      },
      '182': {
        start: {
          line: 428,
          column: 4
        },
        end: {
          line: 428,
          column: 76
        }
      },
      '183': {
        start: {
          line: 429,
          column: 4
        },
        end: {
          line: 429,
          column: 64
        }
      },
      '184': {
        start: {
          line: 430,
          column: 4
        },
        end: {
          line: 430,
          column: 54
        }
      },
      '185': {
        start: {
          line: 431,
          column: 4
        },
        end: {
          line: 431,
          column: 106
        }
      },
      '186': {
        start: {
          line: 432,
          column: 4
        },
        end: {
          line: 442,
          column: 6
        }
      },
      '187': {
        start: {
          line: 443,
          column: 4
        },
        end: {
          line: 443,
          column: 40
        }
      },
      '188': {
        start: {
          line: 444,
          column: 4
        },
        end: {
          line: 444,
          column: 80
        }
      },
      '189': {
        start: {
          line: 445,
          column: 4
        },
        end: {
          line: 449,
          column: 5
        }
      },
      '190': {
        start: {
          line: 446,
          column: 6
        },
        end: {
          line: 448,
          column: 9
        }
      },
      '191': {
        start: {
          line: 447,
          column: 8
        },
        end: {
          line: 447,
          column: 52
        }
      },
      '192': {
        start: {
          line: 450,
          column: 4
        },
        end: {
          line: 450,
          column: 34
        }
      },
      '193': {
        start: {
          line: 451,
          column: 4
        },
        end: {
          line: 460,
          column: 7
        }
      },
      '194': {
        start: {
          line: 452,
          column: 6
        },
        end: {
          line: 457,
          column: 7
        }
      },
      '195': {
        start: {
          line: 453,
          column: 8
        },
        end: {
          line: 456,
          column: 10
        }
      },
      '196': {
        start: {
          line: 459,
          column: 6
        },
        end: {
          line: 459,
          column: 27
        }
      },
      '197': {
        start: {
          line: 461,
          column: 4
        },
        end: {
          line: 464,
          column: 6
        }
      },
      '198': {
        start: {
          line: 465,
          column: 4
        },
        end: {
          line: 467,
          column: 7
        }
      },
      '199': {
        start: {
          line: 466,
          column: 6
        },
        end: {
          line: 466,
          column: 26
        }
      },
      '200': {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 469,
          column: 50
        }
      },
      '201': {
        start: {
          line: 470,
          column: 4
        },
        end: {
          line: 470,
          column: 33
        }
      },
      '202': {
        start: {
          line: 471,
          column: 4
        },
        end: {
          line: 483,
          column: 7
        }
      },
      '203': {
        start: {
          line: 472,
          column: 6
        },
        end: {
          line: 481,
          column: 7
        }
      },
      '204': {
        start: {
          line: 473,
          column: 8
        },
        end: {
          line: 475,
          column: 9
        }
      },
      '205': {
        start: {
          line: 474,
          column: 10
        },
        end: {
          line: 474,
          column: 58
        }
      },
      '206': {
        start: {
          line: 476,
          column: 8
        },
        end: {
          line: 478,
          column: 9
        }
      },
      '207': {
        start: {
          line: 477,
          column: 10
        },
        end: {
          line: 477,
          column: 56
        }
      },
      '208': {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 480,
          column: 39
        }
      },
      '209': {
        start: {
          line: 482,
          column: 6
        },
        end: {
          line: 482,
          column: 34
        }
      },
      '210': {
        start: {
          line: 485,
          column: 2
        },
        end: {
          line: 531,
          column: 4
        }
      },
      '211': {
        start: {
          line: 486,
          column: 4
        },
        end: {
          line: 530,
          column: 7
        }
      },
      '212': {
        start: {
          line: 498,
          column: 6
        },
        end: {
          line: 500,
          column: 7
        }
      },
      '213': {
        start: {
          line: 499,
          column: 8
        },
        end: {
          line: 499,
          column: 15
        }
      },
      '214': {
        start: {
          line: 501,
          column: 6
        },
        end: {
          line: 501,
          column: 30
        }
      },
      '215': {
        start: {
          line: 502,
          column: 27
        },
        end: {
          line: 518,
          column: 7
        }
      },
      '216': {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 529,
          column: 9
        }
      },
      '217': {
        start: {
          line: 520,
          column: 8
        },
        end: {
          line: 527,
          column: 9
        }
      },
      '218': {
        start: {
          line: 521,
          column: 10
        },
        end: {
          line: 524,
          column: 13
        }
      },
      '219': {
        start: {
          line: 525,
          column: 10
        },
        end: {
          line: 525,
          column: 35
        }
      },
      '220': {
        start: {
          line: 526,
          column: 10
        },
        end: {
          line: 526,
          column: 17
        }
      },
      '221': {
        start: {
          line: 528,
          column: 8
        },
        end: {
          line: 528,
          column: 38
        }
      },
      '222': {
        start: {
          line: 533,
          column: 2
        },
        end: {
          line: 552,
          column: 4
        }
      },
      '223': {
        start: {
          line: 534,
          column: 27
        },
        end: {
          line: 534,
          column: 47
        }
      },
      '224': {
        start: {
          line: 535,
          column: 4
        },
        end: {
          line: 535,
          column: 32
        }
      },
      '225': {
        start: {
          line: 536,
          column: 4
        },
        end: {
          line: 551,
          column: 7
        }
      },
      '226': {
        start: {
          line: 537,
          column: 6
        },
        end: {
          line: 547,
          column: 9
        }
      },
      '227': {
        start: {
          line: 548,
          column: 6
        },
        end: {
          line: 548,
          column: 34
        }
      },
      '228': {
        start: {
          line: 549,
          column: 6
        },
        end: {
          line: 549,
          column: 35
        }
      },
      '229': {
        start: {
          line: 550,
          column: 6
        },
        end: {
          line: 550,
          column: 49
        }
      },
      '230': {
        start: {
          line: 553,
          column: 2
        },
        end: {
          line: 562,
          column: 4
        }
      },
      '231': {
        start: {
          line: 554,
          column: 4
        },
        end: {
          line: 561,
          column: 7
        }
      },
      '232': {
        start: {
          line: 564,
          column: 2
        },
        end: {
          line: 577,
          column: 4
        }
      },
      '233': {
        start: {
          line: 565,
          column: 4
        },
        end: {
          line: 565,
          column: 50
        }
      },
      '234': {
        start: {
          line: 566,
          column: 4
        },
        end: {
          line: 566,
          column: 96
        }
      },
      '235': {
        start: {
          line: 567,
          column: 4
        },
        end: {
          line: 567,
          column: 94
        }
      },
      '236': {
        start: {
          line: 569,
          column: 4
        },
        end: {
          line: 576,
          column: 7
        }
      },
      '237': {
        start: {
          line: 578,
          column: 2
        },
        end: {
          line: 596,
          column: 4
        }
      },
      '238': {
        start: {
          line: 579,
          column: 17
        },
        end: {
          line: 586,
          column: 5
        }
      },
      '239': {
        start: {
          line: 588,
          column: 15
        },
        end: {
          line: 588,
          column: 75
        }
      },
      '240': {
        start: {
          line: 589,
          column: 18
        },
        end: {
          line: 589,
          column: 53
        }
      },
      '241': {
        start: {
          line: 590,
          column: 4
        },
        end: {
          line: 594,
          column: 5
        }
      },
      '242': {
        start: {
          line: 591,
          column: 6
        },
        end: {
          line: 591,
          column: 41
        }
      },
      '243': {
        start: {
          line: 593,
          column: 6
        },
        end: {
          line: 593,
          column: 38
        }
      },
      '244': {
        start: {
          line: 598,
          column: 2
        },
        end: {
          line: 623,
          column: 4
        }
      },
      '245': {
        start: {
          line: 599,
          column: 4
        },
        end: {
          line: 622,
          column: 7
        }
      },
      '246': {
        start: {
          line: 612,
          column: 6
        },
        end: {
          line: 614,
          column: 7
        }
      },
      '247': {
        start: {
          line: 613,
          column: 8
        },
        end: {
          line: 613,
          column: 15
        }
      },
      '248': {
        start: {
          line: 615,
          column: 20
        },
        end: {
          line: 615,
          column: 54
        }
      },
      '249': {
        start: {
          line: 616,
          column: 6
        },
        end: {
          line: 621,
          column: 7
        }
      },
      '250': {
        start: {
          line: 617,
          column: 8
        },
        end: {
          line: 619,
          column: 9
        }
      },
      '251': {
        start: {
          line: 618,
          column: 10
        },
        end: {
          line: 618,
          column: 48
        }
      },
      '252': {
        start: {
          line: 620,
          column: 8
        },
        end: {
          line: 620,
          column: 46
        }
      },
      '253': {
        start: {
          line: 625,
          column: 2
        },
        end: {
          line: 625,
          column: 67
        }
      },
      '254': {
        start: {
          line: 627,
          column: 2
        },
        end: {
          line: 627,
          column: 26
        }
      },
      '255': {
        start: {
          line: 628,
          column: 2
        },
        end: {
          line: 634,
          column: 5
        }
      },
      '256': {
        start: {
          line: 629,
          column: 4
        },
        end: {
          line: 632,
          column: 5
        }
      },
      '257': {
        start: {
          line: 630,
          column: 6
        },
        end: {
          line: 630,
          column: 40
        }
      },
      '258': {
        start: {
          line: 631,
          column: 6
        },
        end: {
          line: 631,
          column: 113
        }
      },
      '259': {
        start: {
          line: 633,
          column: 4
        },
        end: {
          line: 633,
          column: 20
        }
      },
      '260': {
        start: {
          line: 636,
          column: 2
        },
        end: {
          line: 636,
          column: 29
        }
      },
      '261': {
        start: {
          line: 638,
          column: 19
        },
        end: {
          line: 643,
          column: 4
        }
      },
      '262': {
        start: {
          line: 645,
          column: 2
        },
        end: {
          line: 649,
          column: 4
        }
      },
      '263': {
        start: {
          line: 646,
          column: 4
        },
        end: {
          line: 646,
          column: 66
        }
      },
      '264': {
        start: {
          line: 647,
          column: 4
        },
        end: {
          line: 647,
          column: 28
        }
      },
      '265': {
        start: {
          line: 648,
          column: 4
        },
        end: {
          line: 648,
          column: 22
        }
      },
      '266': {
        start: {
          line: 651,
          column: 2
        },
        end: {
          line: 654,
          column: 4
        }
      },
      '267': {
        start: {
          line: 652,
          column: 4
        },
        end: {
          line: 652,
          column: 70
        }
      },
      '268': {
        start: {
          line: 653,
          column: 4
        },
        end: {
          line: 653,
          column: 29
        }
      },
      '269': {
        start: {
          line: 656,
          column: 2
        },
        end: {
          line: 659,
          column: 5
        }
      },
      '270': {
        start: {
          line: 657,
          column: 4
        },
        end: {
          line: 657,
          column: 45
        }
      },
      '271': {
        start: {
          line: 658,
          column: 4
        },
        end: {
          line: 658,
          column: 33
        }
      },
      '272': {
        start: {
          line: 661,
          column: 2
        },
        end: {
          line: 663,
          column: 5
        }
      },
      '273': {
        start: {
          line: 662,
          column: 4
        },
        end: {
          line: 662,
          column: 33
        }
      },
      '274': {
        start: {
          line: 665,
          column: 2
        },
        end: {
          line: 681,
          column: 5
        }
      },
      '275': {
        start: {
          line: 666,
          column: 4
        },
        end: {
          line: 666,
          column: 56
        }
      },
      '276': {
        start: {
          line: 667,
          column: 4
        },
        end: {
          line: 672,
          column: 5
        }
      },
      '277': {
        start: {
          line: 668,
          column: 6
        },
        end: {
          line: 670,
          column: 9
        }
      },
      '278': {
        start: {
          line: 669,
          column: 8
        },
        end: {
          line: 669,
          column: 42
        }
      },
      '279': {
        start: {
          line: 671,
          column: 6
        },
        end: {
          line: 671,
          column: 13
        }
      },
      '280': {
        start: {
          line: 673,
          column: 4
        },
        end: {
          line: 679,
          column: 5
        }
      },
      '281': {
        start: {
          line: 674,
          column: 6
        },
        end: {
          line: 678,
          column: 7
        }
      },
      '282': {
        start: {
          line: 675,
          column: 8
        },
        end: {
          line: 675,
          column: 38
        }
      },
      '283': {
        start: {
          line: 676,
          column: 8
        },
        end: {
          line: 676,
          column: 40
        }
      },
      '284': {
        start: {
          line: 677,
          column: 8
        },
        end: {
          line: 677,
          column: 15
        }
      },
      '285': {
        start: {
          line: 680,
          column: 4
        },
        end: {
          line: 680,
          column: 37
        }
      },
      '286': {
        start: {
          line: 683,
          column: 2
        },
        end: {
          line: 699,
          column: 5
        }
      },
      '287': {
        start: {
          line: 684,
          column: 4
        },
        end: {
          line: 684,
          column: 56
        }
      },
      '288': {
        start: {
          line: 685,
          column: 4
        },
        end: {
          line: 690,
          column: 5
        }
      },
      '289': {
        start: {
          line: 686,
          column: 6
        },
        end: {
          line: 688,
          column: 9
        }
      },
      '290': {
        start: {
          line: 687,
          column: 8
        },
        end: {
          line: 687,
          column: 42
        }
      },
      '291': {
        start: {
          line: 689,
          column: 6
        },
        end: {
          line: 689,
          column: 13
        }
      },
      '292': {
        start: {
          line: 691,
          column: 4
        },
        end: {
          line: 697,
          column: 5
        }
      },
      '293': {
        start: {
          line: 692,
          column: 6
        },
        end: {
          line: 696,
          column: 7
        }
      },
      '294': {
        start: {
          line: 693,
          column: 8
        },
        end: {
          line: 693,
          column: 38
        }
      },
      '295': {
        start: {
          line: 694,
          column: 8
        },
        end: {
          line: 694,
          column: 40
        }
      },
      '296': {
        start: {
          line: 695,
          column: 8
        },
        end: {
          line: 695,
          column: 15
        }
      },
      '297': {
        start: {
          line: 698,
          column: 4
        },
        end: {
          line: 698,
          column: 37
        }
      },
      '298': {
        start: {
          line: 702,
          column: 2
        },
        end: {
          line: 711,
          column: 4
        }
      },
      '299': {
        start: {
          line: 703,
          column: 4
        },
        end: {
          line: 710,
          column: 7
        }
      },
      '300': {
        start: {
          line: 713,
          column: 2
        },
        end: {
          line: 722,
          column: 4
        }
      },
      '301': {
        start: {
          line: 714,
          column: 4
        },
        end: {
          line: 721,
          column: 7
        }
      },
      '302': {
        start: {
          line: 727,
          column: 2
        },
        end: {
          line: 732,
          column: 4
        }
      },
      '303': {
        start: {
          line: 728,
          column: 4
        },
        end: {
          line: 731,
          column: 7
        }
      },
      '304': {
        start: {
          line: 734,
          column: 2
        },
        end: {
          line: 737,
          column: 4
        }
      },
      '305': {
        start: {
          line: 735,
          column: 4
        },
        end: {
          line: 735,
          column: 28
        }
      },
      '306': {
        start: {
          line: 736,
          column: 4
        },
        end: {
          line: 736,
          column: 49
        }
      },
      '307': {
        start: {
          line: 739,
          column: 2
        },
        end: {
          line: 741,
          column: 5
        }
      },
      '308': {
        start: {
          line: 740,
          column: 4
        },
        end: {
          line: 740,
          column: 35
        }
      },
      '309': {
        start: {
          line: 743,
          column: 2
        },
        end: {
          line: 776,
          column: 4
        }
      },
      '310': {
        start: {
          line: 744,
          column: 4
        },
        end: {
          line: 744,
          column: 27
        }
      },
      '311': {
        start: {
          line: 745,
          column: 4
        },
        end: {
          line: 745,
          column: 31
        }
      },
      '312': {
        start: {
          line: 747,
          column: 4
        },
        end: {
          line: 751,
          column: 5
        }
      },
      '313': {
        start: {
          line: 748,
          column: 6
        },
        end: {
          line: 748,
          column: 90
        }
      },
      '314': {
        start: {
          line: 750,
          column: 6
        },
        end: {
          line: 750,
          column: 33
        }
      },
      '315': {
        start: {
          line: 754,
          column: 4
        },
        end: {
          line: 757,
          column: 5
        }
      },
      '316': {
        start: {
          line: 755,
          column: 6
        },
        end: {
          line: 755,
          column: 36
        }
      },
      '317': {
        start: {
          line: 756,
          column: 6
        },
        end: {
          line: 756,
          column: 13
        }
      },
      '318': {
        start: {
          line: 760,
          column: 4
        },
        end: {
          line: 766,
          column: 5
        }
      },
      '319': {
        start: {
          line: 761,
          column: 8
        },
        end: {
          line: 762,
          column: 60
        }
      },
      '320': {
        start: {
          line: 764,
          column: 8
        },
        end: {
          line: 764,
          column: 38
        }
      },
      '321': {
        start: {
          line: 765,
          column: 8
        },
        end: {
          line: 765,
          column: 15
        }
      },
      '322': {
        start: {
          line: 768,
          column: 4
        },
        end: {
          line: 775,
          column: 7
        }
      },
      '323': {
        start: {
          line: 772,
          column: 8
        },
        end: {
          line: 772,
          column: 64
        }
      },
      '324': {
        start: {
          line: 773,
          column: 8
        },
        end: {
          line: 773,
          column: 69
        }
      },
      '325': {
        start: {
          line: 774,
          column: 8
        },
        end: {
          line: 774,
          column: 39
        }
      },
      '326': {
        start: {
          line: 778,
          column: 2
        },
        end: {
          line: 810,
          column: 5
        }
      },
      '327': {
        start: {
          line: 779,
          column: 4
        },
        end: {
          line: 809,
          column: 7
        }
      },
      '328': {
        start: {
          line: 791,
          column: 6
        },
        end: {
          line: 793,
          column: 7
        }
      },
      '329': {
        start: {
          line: 792,
          column: 8
        },
        end: {
          line: 792,
          column: 15
        }
      },
      '330': {
        start: {
          line: 794,
          column: 6
        },
        end: {
          line: 794,
          column: 30
        }
      },
      '331': {
        start: {
          line: 795,
          column: 27
        },
        end: {
          line: 797,
          column: 7
        }
      },
      '332': {
        start: {
          line: 798,
          column: 6
        },
        end: {
          line: 808,
          column: 9
        }
      },
      '333': {
        start: {
          line: 799,
          column: 8
        },
        end: {
          line: 806,
          column: 9
        }
      },
      '334': {
        start: {
          line: 800,
          column: 10
        },
        end: {
          line: 803,
          column: 13
        }
      },
      '335': {
        start: {
          line: 804,
          column: 10
        },
        end: {
          line: 804,
          column: 35
        }
      },
      '336': {
        start: {
          line: 805,
          column: 10
        },
        end: {
          line: 805,
          column: 17
        }
      },
      '337': {
        start: {
          line: 807,
          column: 8
        },
        end: {
          line: 807,
          column: 59
        }
      },
      '338': {
        start: {
          line: 812,
          column: 2
        },
        end: {
          line: 814,
          column: 4
        }
      },
      '339': {
        start: {
          line: 813,
          column: 4
        },
        end: {
          line: 813,
          column: 40
        }
      },
      '340': {
        start: {
          line: 818,
          column: 2
        },
        end: {
          line: 823,
          column: 4
        }
      },
      '341': {
        start: {
          line: 819,
          column: 4
        },
        end: {
          line: 822,
          column: 7
        }
      },
      '342': {
        start: {
          line: 825,
          column: 2
        },
        end: {
          line: 828,
          column: 4
        }
      },
      '343': {
        start: {
          line: 826,
          column: 4
        },
        end: {
          line: 826,
          column: 28
        }
      },
      '344': {
        start: {
          line: 827,
          column: 4
        },
        end: {
          line: 827,
          column: 49
        }
      },
      '345': {
        start: {
          line: 830,
          column: 2
        },
        end: {
          line: 832,
          column: 5
        }
      },
      '346': {
        start: {
          line: 831,
          column: 4
        },
        end: {
          line: 831,
          column: 35
        }
      },
      '347': {
        start: {
          line: 834,
          column: 2
        },
        end: {
          line: 867,
          column: 4
        }
      },
      '348': {
        start: {
          line: 835,
          column: 4
        },
        end: {
          line: 835,
          column: 27
        }
      },
      '349': {
        start: {
          line: 838,
          column: 4
        },
        end: {
          line: 842,
          column: 5
        }
      },
      '350': {
        start: {
          line: 839,
          column: 8
        },
        end: {
          line: 839,
          column: 92
        }
      },
      '351': {
        start: {
          line: 841,
          column: 8
        },
        end: {
          line: 841,
          column: 35
        }
      },
      '352': {
        start: {
          line: 845,
          column: 4
        },
        end: {
          line: 848,
          column: 5
        }
      },
      '353': {
        start: {
          line: 846,
          column: 8
        },
        end: {
          line: 846,
          column: 38
        }
      },
      '354': {
        start: {
          line: 847,
          column: 8
        },
        end: {
          line: 847,
          column: 15
        }
      },
      '355': {
        start: {
          line: 851,
          column: 4
        },
        end: {
          line: 857,
          column: 5
        }
      },
      '356': {
        start: {
          line: 852,
          column: 8
        },
        end: {
          line: 853,
          column: 60
        }
      },
      '357': {
        start: {
          line: 855,
          column: 8
        },
        end: {
          line: 855,
          column: 38
        }
      },
      '358': {
        start: {
          line: 856,
          column: 8
        },
        end: {
          line: 856,
          column: 15
        }
      },
      '359': {
        start: {
          line: 859,
          column: 4
        },
        end: {
          line: 866,
          column: 7
        }
      },
      '360': {
        start: {
          line: 863,
          column: 8
        },
        end: {
          line: 863,
          column: 64
        }
      },
      '361': {
        start: {
          line: 864,
          column: 8
        },
        end: {
          line: 864,
          column: 69
        }
      },
      '362': {
        start: {
          line: 865,
          column: 8
        },
        end: {
          line: 865,
          column: 39
        }
      },
      '363': {
        start: {
          line: 869,
          column: 2
        },
        end: {
          line: 900,
          column: 5
        }
      },
      '364': {
        start: {
          line: 870,
          column: 4
        },
        end: {
          line: 899,
          column: 7
        }
      },
      '365': {
        start: {
          line: 881,
          column: 6
        },
        end: {
          line: 883,
          column: 7
        }
      },
      '366': {
        start: {
          line: 882,
          column: 8
        },
        end: {
          line: 882,
          column: 15
        }
      },
      '367': {
        start: {
          line: 884,
          column: 6
        },
        end: {
          line: 884,
          column: 30
        }
      },
      '368': {
        start: {
          line: 885,
          column: 27
        },
        end: {
          line: 887,
          column: 7
        }
      },
      '369': {
        start: {
          line: 888,
          column: 6
        },
        end: {
          line: 898,
          column: 9
        }
      },
      '370': {
        start: {
          line: 889,
          column: 8
        },
        end: {
          line: 896,
          column: 9
        }
      },
      '371': {
        start: {
          line: 890,
          column: 10
        },
        end: {
          line: 893,
          column: 13
        }
      },
      '372': {
        start: {
          line: 894,
          column: 10
        },
        end: {
          line: 894,
          column: 35
        }
      },
      '373': {
        start: {
          line: 895,
          column: 10
        },
        end: {
          line: 895,
          column: 17
        }
      },
      '374': {
        start: {
          line: 897,
          column: 8
        },
        end: {
          line: 897,
          column: 59
        }
      },
      '375': {
        start: {
          line: 902,
          column: 2
        },
        end: {
          line: 904,
          column: 4
        }
      },
      '376': {
        start: {
          line: 903,
          column: 4
        },
        end: {
          line: 903,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: 'milestone_edit',
        decl: {
          start: {
            line: 5,
            column: 9
          },
          end: {
            line: 5,
            column: 23
          }
        },
        loc: {
          start: {
            line: 5,
            column: 86
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 7
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 23
          }
        },
        loc: {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 11
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 15,
            column: 48
          },
          end: {
            line: 15,
            column: 49
          }
        },
        loc: {
          start: {
            line: 15,
            column: 284
          },
          end: {
            line: 725,
            column: 1
          }
        },
        line: 15
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 38
          }
        },
        loc: {
          start: {
            line: 18,
            column: 43
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 18
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 26
          }
        },
        loc: {
          start: {
            line: 24,
            column: 44
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 24
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 37,
            column: 80
          },
          end: {
            line: 37,
            column: 81
          }
        },
        loc: {
          start: {
            line: 37,
            column: 88
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 37
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 44,
            column: 23
          },
          end: {
            line: 44,
            column: 24
          }
        },
        loc: {
          start: {
            line: 44,
            column: 35
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 44
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 72,
            column: 23
          },
          end: {
            line: 72,
            column: 24
          }
        },
        loc: {
          start: {
            line: 72,
            column: 33
          },
          end: {
            line: 80,
            column: 3
          }
        },
        line: 72
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 103,
            column: 18
          },
          end: {
            line: 103,
            column: 19
          }
        },
        loc: {
          start: {
            line: 103,
            column: 30
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 103
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 108,
            column: 81
          },
          end: {
            line: 108,
            column: 82
          }
        },
        loc: {
          start: {
            line: 108,
            column: 90
          },
          end: {
            line: 214,
            column: 5
          }
        },
        line: 108
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 218,
            column: 18
          },
          end: {
            line: 218,
            column: 19
          }
        },
        loc: {
          start: {
            line: 218,
            column: 30
          },
          end: {
            line: 220,
            column: 3
          }
        },
        line: 218
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 21
          }
        },
        loc: {
          start: {
            line: 221,
            column: 32
          },
          end: {
            line: 323,
            column: 3
          }
        },
        line: 221
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 228,
            column: 65
          },
          end: {
            line: 228,
            column: 66
          }
        },
        loc: {
          start: {
            line: 228,
            column: 74
          },
          end: {
            line: 228,
            column: 82
          }
        },
        line: 228
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 313,
            column: 9
          },
          end: {
            line: 313,
            column: 10
          }
        },
        loc: {
          start: {
            line: 313,
            column: 22
          },
          end: {
            line: 318,
            column: 7
          }
        },
        line: 313
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 325,
            column: 30
          },
          end: {
            line: 325,
            column: 31
          }
        },
        loc: {
          start: {
            line: 325,
            column: 36
          },
          end: {
            line: 342,
            column: 3
          }
        },
        line: 325
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 336,
            column: 9
          },
          end: {
            line: 336,
            column: 10
          }
        },
        loc: {
          start: {
            line: 336,
            column: 22
          },
          end: {
            line: 340,
            column: 7
          }
        },
        line: 336
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 344,
            column: 53
          },
          end: {
            line: 344,
            column: 54
          }
        },
        loc: {
          start: {
            line: 344,
            column: 61
          },
          end: {
            line: 355,
            column: 3
          }
        },
        line: 344
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 356,
            column: 25
          },
          end: {
            line: 356,
            column: 26
          }
        },
        loc: {
          start: {
            line: 356,
            column: 49
          },
          end: {
            line: 395,
            column: 3
          }
        },
        line: 356
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 359,
            column: 108
          },
          end: {
            line: 359,
            column: 109
          }
        },
        loc: {
          start: {
            line: 359,
            column: 118
          },
          end: {
            line: 394,
            column: 5
          }
        },
        line: 359
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 378,
            column: 15
          },
          end: {
            line: 378,
            column: 16
          }
        },
        loc: {
          start: {
            line: 378,
            column: 24
          },
          end: {
            line: 382,
            column: 11
          }
        },
        line: 378
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 388,
            column: 130
          },
          end: {
            line: 388,
            column: 131
          }
        },
        loc: {
          start: {
            line: 388,
            column: 139
          },
          end: {
            line: 390,
            column: 9
          }
        },
        line: 388
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 397,
            column: 16
          },
          end: {
            line: 397,
            column: 17
          }
        },
        loc: {
          start: {
            line: 397,
            column: 32
          },
          end: {
            line: 484,
            column: 3
          }
        },
        line: 397
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 410,
            column: 73
          },
          end: {
            line: 410,
            column: 74
          }
        },
        loc: {
          start: {
            line: 410,
            column: 82
          },
          end: {
            line: 412,
            column: 7
          }
        },
        line: 410
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 446,
            column: 67
          },
          end: {
            line: 446,
            column: 68
          }
        },
        loc: {
          start: {
            line: 446,
            column: 75
          },
          end: {
            line: 448,
            column: 7
          }
        },
        line: 446
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 451,
            column: 84
          },
          end: {
            line: 451,
            column: 85
          }
        },
        loc: {
          start: {
            line: 451,
            column: 92
          },
          end: {
            line: 460,
            column: 5
          }
        },
        line: 451
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 465,
            column: 86
          },
          end: {
            line: 465,
            column: 87
          }
        },
        loc: {
          start: {
            line: 465,
            column: 94
          },
          end: {
            line: 467,
            column: 5
          }
        },
        line: 465
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 471,
            column: 62
          },
          end: {
            line: 471,
            column: 63
          }
        },
        loc: {
          start: {
            line: 471,
            column: 70
          },
          end: {
            line: 483,
            column: 5
          }
        },
        line: 471
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 485,
            column: 22
          },
          end: {
            line: 485,
            column: 23
          }
        },
        loc: {
          start: {
            line: 485,
            column: 38
          },
          end: {
            line: 531,
            column: 3
          }
        },
        line: 485
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 497,
            column: 7
          },
          end: {
            line: 497,
            column: 8
          }
        },
        loc: {
          start: {
            line: 497,
            column: 20
          },
          end: {
            line: 530,
            column: 5
          }
        },
        line: 497
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 519,
            column: 95
          },
          end: {
            line: 519,
            column: 96
          }
        },
        loc: {
          start: {
            line: 519,
            column: 103
          },
          end: {
            line: 529,
            column: 7
          }
        },
        line: 519
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 533,
            column: 18
          },
          end: {
            line: 533,
            column: 19
          }
        },
        loc: {
          start: {
            line: 533,
            column: 36
          },
          end: {
            line: 552,
            column: 3
          }
        },
        line: 533
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 536,
            column: 78
          },
          end: {
            line: 536,
            column: 79
          }
        },
        loc: {
          start: {
            line: 536,
            column: 86
          },
          end: {
            line: 551,
            column: 5
          }
        },
        line: 536
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 553,
            column: 24
          },
          end: {
            line: 553,
            column: 25
          }
        },
        loc: {
          start: {
            line: 553,
            column: 36
          },
          end: {
            line: 562,
            column: 3
          }
        },
        line: 553
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 564,
            column: 25
          },
          end: {
            line: 564,
            column: 26
          }
        },
        loc: {
          start: {
            line: 564,
            column: 41
          },
          end: {
            line: 577,
            column: 3
          }
        },
        line: 564
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 578,
            column: 29
          },
          end: {
            line: 578,
            column: 30
          }
        },
        loc: {
          start: {
            line: 578,
            column: 45
          },
          end: {
            line: 596,
            column: 3
          }
        },
        line: 578
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 598,
            column: 27
          },
          end: {
            line: 598,
            column: 28
          }
        },
        loc: {
          start: {
            line: 598,
            column: 43
          },
          end: {
            line: 623,
            column: 3
          }
        },
        line: 598
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 611,
            column: 4
          },
          end: {
            line: 611,
            column: 5
          }
        },
        loc: {
          start: {
            line: 611,
            column: 17
          },
          end: {
            line: 622,
            column: 5
          }
        },
        line: 611
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 628,
            column: 55
          },
          end: {
            line: 628,
            column: 56
          }
        },
        loc: {
          start: {
            line: 628,
            column: 63
          },
          end: {
            line: 634,
            column: 3
          }
        },
        line: 628
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 645,
            column: 31
          },
          end: {
            line: 645,
            column: 32
          }
        },
        loc: {
          start: {
            line: 645,
            column: 66
          },
          end: {
            line: 649,
            column: 3
          }
        },
        line: 645
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 651,
            column: 27
          },
          end: {
            line: 651,
            column: 28
          }
        },
        loc: {
          start: {
            line: 651,
            column: 74
          },
          end: {
            line: 654,
            column: 3
          }
        },
        line: 651
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 656,
            column: 61
          },
          end: {
            line: 656,
            column: 62
          }
        },
        loc: {
          start: {
            line: 656,
            column: 69
          },
          end: {
            line: 659,
            column: 3
          }
        },
        line: 656
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 661,
            column: 61
          },
          end: {
            line: 661,
            column: 62
          }
        },
        loc: {
          start: {
            line: 661,
            column: 69
          },
          end: {
            line: 663,
            column: 3
          }
        },
        line: 661
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 665,
            column: 27
          },
          end: {
            line: 665,
            column: 28
          }
        },
        loc: {
          start: {
            line: 665,
            column: 49
          },
          end: {
            line: 681,
            column: 3
          }
        },
        line: 665
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 668,
            column: 59
          },
          end: {
            line: 668,
            column: 60
          }
        },
        loc: {
          start: {
            line: 668,
            column: 75
          },
          end: {
            line: 670,
            column: 7
          }
        },
        line: 668
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 683,
            column: 27
          },
          end: {
            line: 683,
            column: 28
          }
        },
        loc: {
          start: {
            line: 683,
            column: 49
          },
          end: {
            line: 699,
            column: 3
          }
        },
        line: 683
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 686,
            column: 59
          },
          end: {
            line: 686,
            column: 60
          }
        },
        loc: {
          start: {
            line: 686,
            column: 75
          },
          end: {
            line: 688,
            column: 7
          }
        },
        line: 686
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 702,
            column: 29
          },
          end: {
            line: 702,
            column: 30
          }
        },
        loc: {
          start: {
            line: 702,
            column: 41
          },
          end: {
            line: 711,
            column: 3
          }
        },
        line: 702
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 713,
            column: 29
          },
          end: {
            line: 713,
            column: 30
          }
        },
        loc: {
          start: {
            line: 713,
            column: 41
          },
          end: {
            line: 722,
            column: 3
          }
        },
        line: 713
      },
      '49': {
        name: 'Personnalize_1_Ctrl_Project_edit',
        decl: {
          start: {
            line: 726,
            column: 9
          },
          end: {
            line: 726,
            column: 41
          }
        },
        loc: {
          start: {
            line: 726,
            column: 116
          },
          end: {
            line: 815,
            column: 1
          }
        },
        line: 726
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 727,
            column: 23
          },
          end: {
            line: 727,
            column: 24
          }
        },
        loc: {
          start: {
            line: 727,
            column: 35
          },
          end: {
            line: 732,
            column: 3
          }
        },
        line: 727
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 734,
            column: 24
          },
          end: {
            line: 734,
            column: 25
          }
        },
        loc: {
          start: {
            line: 734,
            column: 40
          },
          end: {
            line: 737,
            column: 3
          }
        },
        line: 734
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 739,
            column: 27
          },
          end: {
            line: 739,
            column: 28
          }
        },
        loc: {
          start: {
            line: 739,
            column: 33
          },
          end: {
            line: 741,
            column: 3
          }
        },
        line: 739
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 743,
            column: 28
          },
          end: {
            line: 743,
            column: 29
          }
        },
        loc: {
          start: {
            line: 743,
            column: 39
          },
          end: {
            line: 776,
            column: 3
          }
        },
        line: 743
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 760,
            column: 37
          },
          end: {
            line: 760,
            column: 38
          }
        },
        loc: {
          start: {
            line: 760,
            column: 49
          },
          end: {
            line: 763,
            column: 5
          }
        },
        line: 760
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 771,
            column: 7
          },
          end: {
            line: 771,
            column: 8
          }
        },
        loc: {
          start: {
            line: 771,
            column: 15
          },
          end: {
            line: 775,
            column: 5
          }
        },
        line: 771
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 778,
            column: 27
          },
          end: {
            line: 778,
            column: 28
          }
        },
        loc: {
          start: {
            line: 778,
            column: 35
          },
          end: {
            line: 810,
            column: 3
          }
        },
        line: 778
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 790,
            column: 7
          },
          end: {
            line: 790,
            column: 8
          }
        },
        loc: {
          start: {
            line: 790,
            column: 20
          },
          end: {
            line: 809,
            column: 5
          }
        },
        line: 790
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 798,
            column: 81
          },
          end: {
            line: 798,
            column: 82
          }
        },
        loc: {
          start: {
            line: 798,
            column: 89
          },
          end: {
            line: 808,
            column: 7
          }
        },
        line: 798
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 812,
            column: 22
          },
          end: {
            line: 812,
            column: 23
          }
        },
        loc: {
          start: {
            line: 812,
            column: 34
          },
          end: {
            line: 814,
            column: 3
          }
        },
        line: 812
      },
      '60': {
        name: 'Personnalize_2_Ctrl_Project_edit',
        decl: {
          start: {
            line: 817,
            column: 9
          },
          end: {
            line: 817,
            column: 41
          }
        },
        loc: {
          start: {
            line: 817,
            column: 116
          },
          end: {
            line: 905,
            column: 1
          }
        },
        line: 817
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 818,
            column: 23
          },
          end: {
            line: 818,
            column: 24
          }
        },
        loc: {
          start: {
            line: 818,
            column: 35
          },
          end: {
            line: 823,
            column: 3
          }
        },
        line: 818
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 825,
            column: 24
          },
          end: {
            line: 825,
            column: 25
          }
        },
        loc: {
          start: {
            line: 825,
            column: 40
          },
          end: {
            line: 828,
            column: 3
          }
        },
        line: 825
      },
      '63': {
        name: '(anonymous_63)',
        decl: {
          start: {
            line: 830,
            column: 27
          },
          end: {
            line: 830,
            column: 28
          }
        },
        loc: {
          start: {
            line: 830,
            column: 33
          },
          end: {
            line: 832,
            column: 3
          }
        },
        line: 830
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 834,
            column: 28
          },
          end: {
            line: 834,
            column: 29
          }
        },
        loc: {
          start: {
            line: 834,
            column: 39
          },
          end: {
            line: 867,
            column: 3
          }
        },
        line: 834
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 851,
            column: 37
          },
          end: {
            line: 851,
            column: 38
          }
        },
        loc: {
          start: {
            line: 851,
            column: 49
          },
          end: {
            line: 854,
            column: 5
          }
        },
        line: 851
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 862,
            column: 7
          },
          end: {
            line: 862,
            column: 8
          }
        },
        loc: {
          start: {
            line: 862,
            column: 15
          },
          end: {
            line: 866,
            column: 5
          }
        },
        line: 862
      },
      '67': {
        name: '(anonymous_67)',
        decl: {
          start: {
            line: 869,
            column: 27
          },
          end: {
            line: 869,
            column: 28
          }
        },
        loc: {
          start: {
            line: 869,
            column: 35
          },
          end: {
            line: 900,
            column: 3
          }
        },
        line: 869
      },
      '68': {
        name: '(anonymous_68)',
        decl: {
          start: {
            line: 880,
            column: 7
          },
          end: {
            line: 880,
            column: 8
          }
        },
        loc: {
          start: {
            line: 880,
            column: 20
          },
          end: {
            line: 899,
            column: 5
          }
        },
        line: 880
      },
      '69': {
        name: '(anonymous_69)',
        decl: {
          start: {
            line: 888,
            column: 81
          },
          end: {
            line: 888,
            column: 82
          }
        },
        loc: {
          start: {
            line: 888,
            column: 89
          },
          end: {
            line: 898,
            column: 7
          }
        },
        line: 888
      },
      '70': {
        name: '(anonymous_70)',
        decl: {
          start: {
            line: 902,
            column: 22
          },
          end: {
            line: 902,
            column: 23
          }
        },
        loc: {
          start: {
            line: 902,
            column: 34
          },
          end: {
            line: 904,
            column: 3
          }
        },
        line: 902
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 36
          }
        }, {
          start: {
            line: 25,
            column: 40
          },
          end: {
            line: 25,
            column: 47
          }
        }],
        line: 25
      },
      '1': {
        loc: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 75
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 51
          }
        }, {
          start: {
            line: 47,
            column: 55
          },
          end: {
            line: 47,
            column: 75
          }
        }],
        line: 47
      },
      '2': {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 75,
            column: 5
          }
        }],
        line: 73
      },
      '3': {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 76
      },
      '4': {
        loc: {
          start: {
            line: 109,
            column: 17
          },
          end: {
            line: 109,
            column: 52
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 109,
            column: 37
          },
          end: {
            line: 109,
            column: 41
          }
        }, {
          start: {
            line: 109,
            column: 44
          },
          end: {
            line: 109,
            column: 52
          }
        }],
        line: 109
      },
      '5': {
        loc: {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        }, {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        }],
        line: 112
      },
      '6': {
        loc: {
          start: {
            line: 185,
            column: 40
          },
          end: {
            line: 185,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 185,
            column: 40
          },
          end: {
            line: 185,
            column: 56
          }
        }, {
          start: {
            line: 185,
            column: 60
          },
          end: {
            line: 185,
            column: 69
          }
        }],
        line: 185
      },
      '7': {
        loc: {
          start: {
            line: 189,
            column: 8
          },
          end: {
            line: 191,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 189,
            column: 8
          },
          end: {
            line: 191,
            column: 9
          }
        }, {
          start: {
            line: 189,
            column: 8
          },
          end: {
            line: 191,
            column: 9
          }
        }],
        line: 189
      },
      '8': {
        loc: {
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        }, {
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        }],
        line: 192
      },
      '9': {
        loc: {
          start: {
            line: 229,
            column: 33
          },
          end: {
            line: 229,
            column: 112
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 229,
            column: 107
          },
          end: {
            line: 229,
            column: 108
          }
        }, {
          start: {
            line: 229,
            column: 111
          },
          end: {
            line: 229,
            column: 112
          }
        }],
        line: 229
      },
      '10': {
        loc: {
          start: {
            line: 229,
            column: 34
          },
          end: {
            line: 229,
            column: 103
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 229,
            column: 34
          },
          end: {
            line: 229,
            column: 66
          }
        }, {
          start: {
            line: 229,
            column: 70
          },
          end: {
            line: 229,
            column: 103
          }
        }],
        line: 229
      },
      '11': {
        loc: {
          start: {
            line: 231,
            column: 31
          },
          end: {
            line: 231,
            column: 70
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 231,
            column: 65
          },
          end: {
            line: 231,
            column: 66
          }
        }, {
          start: {
            line: 231,
            column: 69
          },
          end: {
            line: 231,
            column: 70
          }
        }],
        line: 231
      },
      '12': {
        loc: {
          start: {
            line: 232,
            column: 35
          },
          end: {
            line: 232,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 232,
            column: 73
          },
          end: {
            line: 232,
            column: 74
          }
        }, {
          start: {
            line: 232,
            column: 77
          },
          end: {
            line: 232,
            column: 78
          }
        }],
        line: 232
      },
      '13': {
        loc: {
          start: {
            line: 233,
            column: 38
          },
          end: {
            line: 233,
            column: 125
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 233,
            column: 120
          },
          end: {
            line: 233,
            column: 121
          }
        }, {
          start: {
            line: 233,
            column: 124
          },
          end: {
            line: 233,
            column: 125
          }
        }],
        line: 233
      },
      '14': {
        loc: {
          start: {
            line: 233,
            column: 39
          },
          end: {
            line: 233,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 233,
            column: 39
          },
          end: {
            line: 233,
            column: 74
          }
        }, {
          start: {
            line: 233,
            column: 78
          },
          end: {
            line: 233,
            column: 116
          }
        }],
        line: 233
      },
      '15': {
        loc: {
          start: {
            line: 234,
            column: 32
          },
          end: {
            line: 234,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 234,
            column: 67
          },
          end: {
            line: 234,
            column: 68
          }
        }, {
          start: {
            line: 234,
            column: 71
          },
          end: {
            line: 234,
            column: 72
          }
        }],
        line: 234
      },
      '16': {
        loc: {
          start: {
            line: 236,
            column: 38
          },
          end: {
            line: 236,
            column: 84
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 236,
            column: 79
          },
          end: {
            line: 236,
            column: 80
          }
        }, {
          start: {
            line: 236,
            column: 83
          },
          end: {
            line: 236,
            column: 84
          }
        }],
        line: 236
      },
      '17': {
        loc: {
          start: {
            line: 237,
            column: 48
          },
          end: {
            line: 237,
            column: 104
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 237,
            column: 99
          },
          end: {
            line: 237,
            column: 100
          }
        }, {
          start: {
            line: 237,
            column: 103
          },
          end: {
            line: 237,
            column: 104
          }
        }],
        line: 237
      },
      '18': {
        loc: {
          start: {
            line: 238,
            column: 32
          },
          end: {
            line: 238,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 238,
            column: 67
          },
          end: {
            line: 238,
            column: 68
          }
        }, {
          start: {
            line: 238,
            column: 71
          },
          end: {
            line: 238,
            column: 72
          }
        }],
        line: 238
      },
      '19': {
        loc: {
          start: {
            line: 239,
            column: 28
          },
          end: {
            line: 239,
            column: 64
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 239,
            column: 59
          },
          end: {
            line: 239,
            column: 60
          }
        }, {
          start: {
            line: 239,
            column: 63
          },
          end: {
            line: 239,
            column: 64
          }
        }],
        line: 239
      },
      '20': {
        loc: {
          start: {
            line: 240,
            column: 24
          },
          end: {
            line: 240,
            column: 56
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 240,
            column: 51
          },
          end: {
            line: 240,
            column: 52
          }
        }, {
          start: {
            line: 240,
            column: 55
          },
          end: {
            line: 240,
            column: 56
          }
        }],
        line: 240
      },
      '21': {
        loc: {
          start: {
            line: 241,
            column: 27
          },
          end: {
            line: 241,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 241,
            column: 57
          },
          end: {
            line: 241,
            column: 58
          }
        }, {
          start: {
            line: 241,
            column: 61
          },
          end: {
            line: 241,
            column: 62
          }
        }],
        line: 241
      },
      '22': {
        loc: {
          start: {
            line: 242,
            column: 30
          },
          end: {
            line: 242,
            column: 68
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 242,
            column: 63
          },
          end: {
            line: 242,
            column: 64
          }
        }, {
          start: {
            line: 242,
            column: 67
          },
          end: {
            line: 242,
            column: 68
          }
        }],
        line: 242
      },
      '23': {
        loc: {
          start: {
            line: 243,
            column: 30
          },
          end: {
            line: 243,
            column: 68
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 243,
            column: 63
          },
          end: {
            line: 243,
            column: 64
          }
        }, {
          start: {
            line: 243,
            column: 67
          },
          end: {
            line: 243,
            column: 68
          }
        }],
        line: 243
      },
      '24': {
        loc: {
          start: {
            line: 245,
            column: 27
          },
          end: {
            line: 245,
            column: 62
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 245,
            column: 57
          },
          end: {
            line: 245,
            column: 58
          }
        }, {
          start: {
            line: 245,
            column: 61
          },
          end: {
            line: 245,
            column: 62
          }
        }],
        line: 245
      },
      '25': {
        loc: {
          start: {
            line: 253,
            column: 9
          },
          end: {
            line: 253,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 253,
            column: 38
          },
          end: {
            line: 253,
            column: 41
          }
        }, {
          start: {
            line: 253,
            column: 44
          },
          end: {
            line: 253,
            column: 47
          }
        }],
        line: 253
      },
      '26': {
        loc: {
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 254,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 254,
            column: 40
          },
          end: {
            line: 254,
            column: 43
          }
        }, {
          start: {
            line: 254,
            column: 46
          },
          end: {
            line: 254,
            column: 49
          }
        }],
        line: 254
      },
      '27': {
        loc: {
          start: {
            line: 255,
            column: 10
          },
          end: {
            line: 255,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 255,
            column: 40
          },
          end: {
            line: 255,
            column: 43
          }
        }, {
          start: {
            line: 255,
            column: 46
          },
          end: {
            line: 255,
            column: 49
          }
        }],
        line: 255
      },
      '28': {
        loc: {
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 256,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 256,
            column: 40
          },
          end: {
            line: 256,
            column: 43
          }
        }, {
          start: {
            line: 256,
            column: 46
          },
          end: {
            line: 256,
            column: 49
          }
        }],
        line: 256
      },
      '29': {
        loc: {
          start: {
            line: 257,
            column: 9
          },
          end: {
            line: 257,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 257,
            column: 38
          },
          end: {
            line: 257,
            column: 41
          }
        }, {
          start: {
            line: 257,
            column: 44
          },
          end: {
            line: 257,
            column: 47
          }
        }],
        line: 257
      },
      '30': {
        loc: {
          start: {
            line: 258,
            column: 10
          },
          end: {
            line: 258,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 258,
            column: 40
          },
          end: {
            line: 258,
            column: 43
          }
        }, {
          start: {
            line: 258,
            column: 46
          },
          end: {
            line: 258,
            column: 49
          }
        }],
        line: 258
      },
      '31': {
        loc: {
          start: {
            line: 259,
            column: 10
          },
          end: {
            line: 259,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 259,
            column: 40
          },
          end: {
            line: 259,
            column: 43
          }
        }, {
          start: {
            line: 259,
            column: 46
          },
          end: {
            line: 259,
            column: 49
          }
        }],
        line: 259
      },
      '32': {
        loc: {
          start: {
            line: 260,
            column: 10
          },
          end: {
            line: 260,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 260,
            column: 40
          },
          end: {
            line: 260,
            column: 43
          }
        }, {
          start: {
            line: 260,
            column: 46
          },
          end: {
            line: 260,
            column: 49
          }
        }],
        line: 260
      },
      '33': {
        loc: {
          start: {
            line: 261,
            column: 10
          },
          end: {
            line: 261,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 261,
            column: 40
          },
          end: {
            line: 261,
            column: 43
          }
        }, {
          start: {
            line: 261,
            column: 46
          },
          end: {
            line: 261,
            column: 49
          }
        }],
        line: 261
      },
      '34': {
        loc: {
          start: {
            line: 270,
            column: 6
          },
          end: {
            line: 280,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 270,
            column: 6
          },
          end: {
            line: 280,
            column: 7
          }
        }, {
          start: {
            line: 270,
            column: 6
          },
          end: {
            line: 280,
            column: 7
          }
        }],
        line: 270
      },
      '35': {
        loc: {
          start: {
            line: 272,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 272,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        }, {
          start: {
            line: 272,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        }],
        line: 272
      },
      '36': {
        loc: {
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 272,
            column: 80
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 272,
            column: 38
          }
        }, {
          start: {
            line: 272,
            column: 42
          },
          end: {
            line: 272,
            column: 80
          }
        }],
        line: 272
      },
      '37': {
        loc: {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        }, {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 289,
            column: 5
          }
        }],
        line: 282
      },
      '38': {
        loc: {
          start: {
            line: 290,
            column: 4
          },
          end: {
            line: 297,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 290,
            column: 4
          },
          end: {
            line: 297,
            column: 5
          }
        }, {
          start: {
            line: 290,
            column: 4
          },
          end: {
            line: 297,
            column: 5
          }
        }],
        line: 290
      },
      '39': {
        loc: {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        }, {
          start: {
            line: 302,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        }],
        line: 302
      },
      '40': {
        loc: {
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 302,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 302,
            column: 59
          }
        }, {
          start: {
            line: 302,
            column: 63
          },
          end: {
            line: 302,
            column: 83
          }
        }],
        line: 302
      },
      '41': {
        loc: {
          start: {
            line: 314,
            column: 8
          },
          end: {
            line: 316,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 314,
            column: 8
          },
          end: {
            line: 316,
            column: 9
          }
        }, {
          start: {
            line: 314,
            column: 8
          },
          end: {
            line: 316,
            column: 9
          }
        }],
        line: 314
      },
      '42': {
        loc: {
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        }, {
          start: {
            line: 326,
            column: 4
          },
          end: {
            line: 341,
            column: 5
          }
        }],
        line: 326
      },
      '43': {
        loc: {
          start: {
            line: 337,
            column: 8
          },
          end: {
            line: 339,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 337,
            column: 8
          },
          end: {
            line: 339,
            column: 9
          }
        }, {
          start: {
            line: 337,
            column: 8
          },
          end: {
            line: 339,
            column: 9
          }
        }],
        line: 337
      },
      '44': {
        loc: {
          start: {
            line: 361,
            column: 6
          },
          end: {
            line: 384,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 361,
            column: 6
          },
          end: {
            line: 384,
            column: 7
          }
        }, {
          start: {
            line: 361,
            column: 6
          },
          end: {
            line: 384,
            column: 7
          }
        }],
        line: 361
      },
      '45': {
        loc: {
          start: {
            line: 365,
            column: 25
          },
          end: {
            line: 365,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 365,
            column: 25
          },
          end: {
            line: 365,
            column: 48
          }
        }, {
          start: {
            line: 365,
            column: 52
          },
          end: {
            line: 365,
            column: 54
          }
        }],
        line: 365
      },
      '46': {
        loc: {
          start: {
            line: 370,
            column: 30
          },
          end: {
            line: 370,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 370,
            column: 50
          },
          end: {
            line: 370,
            column: 51
          }
        }, {
          start: {
            line: 370,
            column: 54
          },
          end: {
            line: 370,
            column: 55
          }
        }],
        line: 370
      },
      '47': {
        loc: {
          start: {
            line: 379,
            column: 12
          },
          end: {
            line: 381,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 379,
            column: 12
          },
          end: {
            line: 381,
            column: 13
          }
        }, {
          start: {
            line: 379,
            column: 12
          },
          end: {
            line: 381,
            column: 13
          }
        }],
        line: 379
      },
      '48': {
        loc: {
          start: {
            line: 387,
            column: 6
          },
          end: {
            line: 391,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 387,
            column: 6
          },
          end: {
            line: 391,
            column: 7
          }
        }, {
          start: {
            line: 387,
            column: 6
          },
          end: {
            line: 391,
            column: 7
          }
        }],
        line: 387
      },
      '49': {
        loc: {
          start: {
            line: 387,
            column: 10
          },
          end: {
            line: 387,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 387,
            column: 30
          }
        }, {
          start: {
            line: 387,
            column: 36
          },
          end: {
            line: 387,
            column: 64
          }
        }],
        line: 387
      },
      '50': {
        loc: {
          start: {
            line: 406,
            column: 89
          },
          end: {
            line: 406,
            column: 116
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 406,
            column: 89
          },
          end: {
            line: 406,
            column: 109
          }
        }, {
          start: {
            line: 406,
            column: 113
          },
          end: {
            line: 406,
            column: 116
          }
        }],
        line: 406
      },
      '51': {
        loc: {
          start: {
            line: 407,
            column: 76
          },
          end: {
            line: 407,
            column: 106
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 407,
            column: 76
          },
          end: {
            line: 407,
            column: 101
          }
        }, {
          start: {
            line: 407,
            column: 105
          },
          end: {
            line: 407,
            column: 106
          }
        }],
        line: 407
      },
      '52': {
        loc: {
          start: {
            line: 409,
            column: 4
          },
          end: {
            line: 417,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 409,
            column: 4
          },
          end: {
            line: 417,
            column: 5
          }
        }, {
          start: {
            line: 409,
            column: 4
          },
          end: {
            line: 417,
            column: 5
          }
        }],
        line: 409
      },
      '53': {
        loc: {
          start: {
            line: 409,
            column: 7
          },
          end: {
            line: 409,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 409,
            column: 7
          },
          end: {
            line: 409,
            column: 33
          }
        }, {
          start: {
            line: 409,
            column: 37
          },
          end: {
            line: 409,
            column: 74
          }
        }],
        line: 409
      },
      '54': {
        loc: {
          start: {
            line: 414,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 414,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        }, {
          start: {
            line: 414,
            column: 6
          },
          end: {
            line: 416,
            column: 7
          }
        }],
        line: 414
      },
      '55': {
        loc: {
          start: {
            line: 425,
            column: 92
          },
          end: {
            line: 425,
            column: 113
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 425,
            column: 92
          },
          end: {
            line: 425,
            column: 108
          }
        }, {
          start: {
            line: 425,
            column: 112
          },
          end: {
            line: 425,
            column: 113
          }
        }],
        line: 425
      },
      '56': {
        loc: {
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 449,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 449,
            column: 5
          }
        }, {
          start: {
            line: 445,
            column: 4
          },
          end: {
            line: 449,
            column: 5
          }
        }],
        line: 445
      },
      '57': {
        loc: {
          start: {
            line: 471,
            column: 47
          },
          end: {
            line: 471,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 471,
            column: 47
          },
          end: {
            line: 471,
            column: 54
          }
        }, {
          start: {
            line: 471,
            column: 58
          },
          end: {
            line: 471,
            column: 59
          }
        }],
        line: 471
      },
      '58': {
        loc: {
          start: {
            line: 473,
            column: 8
          },
          end: {
            line: 475,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 473,
            column: 8
          },
          end: {
            line: 475,
            column: 9
          }
        }, {
          start: {
            line: 473,
            column: 8
          },
          end: {
            line: 475,
            column: 9
          }
        }],
        line: 473
      },
      '59': {
        loc: {
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        }, {
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 478,
            column: 9
          }
        }],
        line: 476
      },
      '60': {
        loc: {
          start: {
            line: 498,
            column: 6
          },
          end: {
            line: 500,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 498,
            column: 6
          },
          end: {
            line: 500,
            column: 7
          }
        }, {
          start: {
            line: 498,
            column: 6
          },
          end: {
            line: 500,
            column: 7
          }
        }],
        line: 498
      },
      '61': {
        loc: {
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        }, {
          start: {
            line: 520,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        }],
        line: 520
      },
      '62': {
        loc: {
          start: {
            line: 590,
            column: 4
          },
          end: {
            line: 594,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 590,
            column: 4
          },
          end: {
            line: 594,
            column: 5
          }
        }, {
          start: {
            line: 590,
            column: 4
          },
          end: {
            line: 594,
            column: 5
          }
        }],
        line: 590
      },
      '63': {
        loc: {
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 614,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 614,
            column: 7
          }
        }, {
          start: {
            line: 612,
            column: 6
          },
          end: {
            line: 614,
            column: 7
          }
        }],
        line: 612
      },
      '64': {
        loc: {
          start: {
            line: 616,
            column: 6
          },
          end: {
            line: 621,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 616,
            column: 6
          },
          end: {
            line: 621,
            column: 7
          }
        }, {
          start: {
            line: 616,
            column: 6
          },
          end: {
            line: 621,
            column: 7
          }
        }],
        line: 616
      },
      '65': {
        loc: {
          start: {
            line: 617,
            column: 8
          },
          end: {
            line: 619,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 617,
            column: 8
          },
          end: {
            line: 619,
            column: 9
          }
        }, {
          start: {
            line: 617,
            column: 8
          },
          end: {
            line: 619,
            column: 9
          }
        }],
        line: 617
      },
      '66': {
        loc: {
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 632,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 632,
            column: 5
          }
        }, {
          start: {
            line: 629,
            column: 4
          },
          end: {
            line: 632,
            column: 5
          }
        }],
        line: 629
      },
      '67': {
        loc: {
          start: {
            line: 666,
            column: 28
          },
          end: {
            line: 666,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 666,
            column: 28
          },
          end: {
            line: 666,
            column: 49
          }
        }, {
          start: {
            line: 666,
            column: 53
          },
          end: {
            line: 666,
            column: 55
          }
        }],
        line: 666
      },
      '68': {
        loc: {
          start: {
            line: 667,
            column: 4
          },
          end: {
            line: 672,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 667,
            column: 4
          },
          end: {
            line: 672,
            column: 5
          }
        }, {
          start: {
            line: 667,
            column: 4
          },
          end: {
            line: 672,
            column: 5
          }
        }],
        line: 667
      },
      '69': {
        loc: {
          start: {
            line: 674,
            column: 6
          },
          end: {
            line: 678,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 674,
            column: 6
          },
          end: {
            line: 678,
            column: 7
          }
        }, {
          start: {
            line: 674,
            column: 6
          },
          end: {
            line: 678,
            column: 7
          }
        }],
        line: 674
      },
      '70': {
        loc: {
          start: {
            line: 684,
            column: 28
          },
          end: {
            line: 684,
            column: 55
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 684,
            column: 28
          },
          end: {
            line: 684,
            column: 49
          }
        }, {
          start: {
            line: 684,
            column: 53
          },
          end: {
            line: 684,
            column: 55
          }
        }],
        line: 684
      },
      '71': {
        loc: {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 690,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 690,
            column: 5
          }
        }, {
          start: {
            line: 685,
            column: 4
          },
          end: {
            line: 690,
            column: 5
          }
        }],
        line: 685
      },
      '72': {
        loc: {
          start: {
            line: 692,
            column: 6
          },
          end: {
            line: 696,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 692,
            column: 6
          },
          end: {
            line: 696,
            column: 7
          }
        }, {
          start: {
            line: 692,
            column: 6
          },
          end: {
            line: 696,
            column: 7
          }
        }],
        line: 692
      },
      '73': {
        loc: {
          start: {
            line: 747,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 747,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        }, {
          start: {
            line: 747,
            column: 4
          },
          end: {
            line: 751,
            column: 5
          }
        }],
        line: 747
      },
      '74': {
        loc: {
          start: {
            line: 747,
            column: 8
          },
          end: {
            line: 747,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 747,
            column: 8
          },
          end: {
            line: 747,
            column: 30
          }
        }, {
          start: {
            line: 747,
            column: 34
          },
          end: {
            line: 747,
            column: 71
          }
        }],
        line: 747
      },
      '75': {
        loc: {
          start: {
            line: 754,
            column: 4
          },
          end: {
            line: 757,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 754,
            column: 4
          },
          end: {
            line: 757,
            column: 5
          }
        }, {
          start: {
            line: 754,
            column: 4
          },
          end: {
            line: 757,
            column: 5
          }
        }],
        line: 754
      },
      '76': {
        loc: {
          start: {
            line: 754,
            column: 8
          },
          end: {
            line: 754,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 754,
            column: 8
          },
          end: {
            line: 754,
            column: 32
          }
        }, {
          start: {
            line: 754,
            column: 36
          },
          end: {
            line: 754,
            column: 65
          }
        }],
        line: 754
      },
      '77': {
        loc: {
          start: {
            line: 760,
            column: 4
          },
          end: {
            line: 766,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 760,
            column: 4
          },
          end: {
            line: 766,
            column: 5
          }
        }, {
          start: {
            line: 760,
            column: 4
          },
          end: {
            line: 766,
            column: 5
          }
        }],
        line: 760
      },
      '78': {
        loc: {
          start: {
            line: 761,
            column: 15
          },
          end: {
            line: 762,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 761,
            column: 15
          },
          end: {
            line: 761,
            column: 89
          }
        }, {
          start: {
            line: 762,
            column: 18
          },
          end: {
            line: 762,
            column: 59
          }
        }],
        line: 761
      },
      '79': {
        loc: {
          start: {
            line: 791,
            column: 6
          },
          end: {
            line: 793,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 791,
            column: 6
          },
          end: {
            line: 793,
            column: 7
          }
        }, {
          start: {
            line: 791,
            column: 6
          },
          end: {
            line: 793,
            column: 7
          }
        }],
        line: 791
      },
      '80': {
        loc: {
          start: {
            line: 799,
            column: 8
          },
          end: {
            line: 806,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 799,
            column: 8
          },
          end: {
            line: 806,
            column: 9
          }
        }, {
          start: {
            line: 799,
            column: 8
          },
          end: {
            line: 806,
            column: 9
          }
        }],
        line: 799
      },
      '81': {
        loc: {
          start: {
            line: 838,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 838,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        }, {
          start: {
            line: 838,
            column: 4
          },
          end: {
            line: 842,
            column: 5
          }
        }],
        line: 838
      },
      '82': {
        loc: {
          start: {
            line: 838,
            column: 8
          },
          end: {
            line: 838,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 838,
            column: 8
          },
          end: {
            line: 838,
            column: 30
          }
        }, {
          start: {
            line: 838,
            column: 34
          },
          end: {
            line: 838,
            column: 71
          }
        }],
        line: 838
      },
      '83': {
        loc: {
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 848,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 848,
            column: 5
          }
        }, {
          start: {
            line: 845,
            column: 4
          },
          end: {
            line: 848,
            column: 5
          }
        }],
        line: 845
      },
      '84': {
        loc: {
          start: {
            line: 845,
            column: 8
          },
          end: {
            line: 845,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 845,
            column: 8
          },
          end: {
            line: 845,
            column: 32
          }
        }, {
          start: {
            line: 845,
            column: 36
          },
          end: {
            line: 845,
            column: 65
          }
        }],
        line: 845
      },
      '85': {
        loc: {
          start: {
            line: 851,
            column: 4
          },
          end: {
            line: 857,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 851,
            column: 4
          },
          end: {
            line: 857,
            column: 5
          }
        }, {
          start: {
            line: 851,
            column: 4
          },
          end: {
            line: 857,
            column: 5
          }
        }],
        line: 851
      },
      '86': {
        loc: {
          start: {
            line: 852,
            column: 15
          },
          end: {
            line: 853,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 852,
            column: 15
          },
          end: {
            line: 852,
            column: 89
          }
        }, {
          start: {
            line: 853,
            column: 18
          },
          end: {
            line: 853,
            column: 59
          }
        }],
        line: 852
      },
      '87': {
        loc: {
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 883,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 883,
            column: 7
          }
        }, {
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 883,
            column: 7
          }
        }],
        line: 881
      },
      '88': {
        loc: {
          start: {
            line: 889,
            column: 8
          },
          end: {
            line: 896,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 889,
            column: 8
          },
          end: {
            line: 896,
            column: 9
          }
        }, {
          start: {
            line: 889,
            column: 8
          },
          end: {
            line: 896,
            column: 9
          }
        }],
        line: 889
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0,
      '368': 0,
      '369': 0,
      '370': 0,
      '371': 0,
      '372': 0,
      '373': 0,
      '374': 0,
      '375': 0,
      '376': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0],
      '81': [0, 0],
      '82': [0, 0],
      '83': [0, 0],
      '84': [0, 0],
      '85': [0, 0],
      '86': [0, 0],
      '87': [0, 0],
      '88': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function milestone_edit($scope, $uibModalInstance, $filter, $CRUDService, $translate) {
  cov_aer4v9vw8.f[0]++;

  var PATH = (cov_aer4v9vw8.s[0]++, 'MILESTONE');
  cov_aer4v9vw8.s[1]++;
  $scope.setValidData = function (item) {
    cov_aer4v9vw8.f[1]++;
    cov_aer4v9vw8.s[2]++;

    $scope.validateMilestone(item);
    cov_aer4v9vw8.s[3]++;
    $scope.closeModal();
  };
  cov_aer4v9vw8.s[4]++;
  $scope.closeModal = function () {
    cov_aer4v9vw8.f[2]++;
    cov_aer4v9vw8.s[5]++;

    $uibModalInstance.dismiss('cancel');
  };
}
cov_aer4v9vw8.s[6]++;
angular.module('app').controller('ProgramCtrl', function ($scope, $stateParams, $state, $deltaclearData, $deltaPlanLogique, $log, $deltaGeoData, SweetAlert, $rootScope, $deltadate, $translate, $CRUDService, $otherHttpService, $deltahttp, $location, $filter, FileUploader, $http, $uibModal) {
  cov_aer4v9vw8.f[3]++;

  var PATH = (cov_aer4v9vw8.s[7]++, 'Milestone');
  cov_aer4v9vw8.s[8]++;
  $rootScope.personnalPortfolio.getLabelPortfolio();
  cov_aer4v9vw8.s[9]++;
  $rootScope.processPageRight('1_1', function () {
    cov_aer4v9vw8.f[4]++;
    cov_aer4v9vw8.s[10]++;

    $rootScope.global_access_page_denied = false;
    cov_aer4v9vw8.s[11]++;
    $rootScope.currentRight.v = true;
  });

  cov_aer4v9vw8.s[12]++;
  $scope.selectedProgram = { id: 0 };
  cov_aer4v9vw8.s[13]++;
  $scope.selectProgram = function (program) {
    cov_aer4v9vw8.f[5]++;
    cov_aer4v9vw8.s[14]++;

    $scope.selectedProgram = (cov_aer4v9vw8.b[0][0]++, program) || (cov_aer4v9vw8.b[0][1]++, { id: 0 });
  };

  cov_aer4v9vw8.s[15]++;
  $scope.view = {
    tab: 1,
    activeOnglet: 0
  };
  cov_aer4v9vw8.s[16]++;
  $scope.listMonths = $deltadate.getPeriods(Date.newDate('1989-01-01'), Date.newDate('1989-12-31'), 12, false, 1);
  cov_aer4v9vw8.s[17]++;
  $scope.listMilestone = [];
  cov_aer4v9vw8.s[18]++;
  $scope.listProjects = [];
  cov_aer4v9vw8.s[19]++;
  $scope.PATH = 'Projet';

  cov_aer4v9vw8.s[20]++;
  $CRUDService.getAll($scope.PATH, { get: 'cross_cutting_state', defined: true }, function (data) {
    cov_aer4v9vw8.f[6]++;
    cov_aer4v9vw8.s[21]++;

    $scope.editCrossState = data;
  });

  cov_aer4v9vw8.s[22]++;
  $scope.contries = [{ id: 1, name: $translate.instant('COUNTRIES.AF') }, { id: 2, name: $translate.instant('COUNTRIES.AX') }, { id: 3, name: $translate.instant('COUNTRIES.AL') }, { id: 4, name: $translate.instant('COUNTRIES.DZ') }, { id: 5, name: $translate.instant('COUNTRIES.AS') }, { id: 6, name: $translate.instant('COUNTRIES.AD') }, { id: 7, name: $translate.instant('COUNTRIES.AO') }, { id: 8, name: $translate.instant('COUNTRIES.AI') }, { id: 9, name: $translate.instant('COUNTRIES.AQ') }, { id: 10, name: $translate.instant('COUNTRIES.AG') }, { id: 11, name: $translate.instant('COUNTRIES.AR') }, { id: 12, name: $translate.instant('COUNTRIES.AM') }, { id: 13, name: $translate.instant('COUNTRIES.AW') }, { id: 14, name: $translate.instant('COUNTRIES.AU') }, { id: 15, name: $translate.instant('COUNTRIES.AT') }, { id: 16, name: $translate.instant('COUNTRIES.AZ') }, { id: 17, name: $translate.instant('COUNTRIES.BS') }, { id: 18, name: $translate.instant('COUNTRIES.BH') }, { id: 19, name: $translate.instant('COUNTRIES.BD') }, { id: 20, name: $translate.instant('COUNTRIES.BB') }, { id: 21, name: $translate.instant('COUNTRIES.BY') }, { id: 22, name: $translate.instant('COUNTRIES.BE') }, { id: 23, name: $translate.instant('COUNTRIES.BZ') }, { id: 24, name: $translate.instant('COUNTRIES.BJ') }, { id: 25, name: $translate.instant('COUNTRIES.BM') }, { id: 26, name: $translate.instant('COUNTRIES.BT') }, { id: 27, name: $translate.instant('COUNTRIES.BO') }, { id: 28, name: $translate.instant('COUNTRIES.BA') }, { id: 29, name: $translate.instant('COUNTRIES.BW') }, { id: 30, name: $translate.instant('COUNTRIES.BV') }, { id: 31, name: $translate.instant('COUNTRIES.BR') }, { id: 32, name: $translate.instant('COUNTRIES.IO') }, { id: 33, name: $translate.instant('COUNTRIES.BN') }, { id: 34, name: $translate.instant('COUNTRIES.BG') }, { id: 35, name: $translate.instant('COUNTRIES.BF') }, { id: 36, name: $translate.instant('COUNTRIES.BI') }, { id: 37, name: $translate.instant('COUNTRIES.KH') }, { id: 38, name: $translate.instant('COUNTRIES.CM') }, { id: 39, name: $translate.instant('COUNTRIES.CA') }, { id: 40, name: $translate.instant('COUNTRIES.CV') }, { id: 41, name: $translate.instant('COUNTRIES.KY') }, { id: 42, name: $translate.instant('COUNTRIES.CF') }, { id: 43, name: $translate.instant('COUNTRIES.TD') }, { id: 44, name: $translate.instant('COUNTRIES.CL') }, { id: 45, name: $translate.instant('COUNTRIES.CN') }, { id: 46, name: $translate.instant('COUNTRIES.CX') }, { id: 47, name: $translate.instant('COUNTRIES.CC') }, { id: 48, name: $translate.instant('COUNTRIES.CO') }, { id: 49, name: $translate.instant('COUNTRIES.KM') }, { id: 50, name: $translate.instant('COUNTRIES.CG') }, { id: 51, name: $translate.instant('COUNTRIES.CD') }, { id: 52, name: $translate.instant('COUNTRIES.CK') }, { id: 53, name: $translate.instant('COUNTRIES.CR') }, { id: 54, name: $translate.instant('COUNTRIES.CI') }, { id: 55, name: $translate.instant('COUNTRIES.HR') }, { id: 56, name: $translate.instant('COUNTRIES.CU') }, { id: 57, name: $translate.instant('COUNTRIES.CY') }, { id: 58, name: $translate.instant('COUNTRIES.CZ') }, { id: 59, name: $translate.instant('COUNTRIES.DK') }, { id: 60, name: $translate.instant('COUNTRIES.DJ') }, { id: 61, name: $translate.instant('COUNTRIES.DM') }, { id: 62, name: $translate.instant('COUNTRIES.DO') }, { id: 63, name: $translate.instant('COUNTRIES.EC') }, { id: 64, name: $translate.instant('COUNTRIES.EG') }, { id: 65, name: $translate.instant('COUNTRIES.SV') }, { id: 66, name: $translate.instant('COUNTRIES.GQ') }, { id: 67, name: $translate.instant('COUNTRIES.ER') }, { id: 68, name: $translate.instant('COUNTRIES.EE') }, { id: 69, name: $translate.instant('COUNTRIES.ET') }, { id: 70, name: $translate.instant('COUNTRIES.FK') }, { id: 71, name: $translate.instant('COUNTRIES.FO') }, { id: 72, name: $translate.instant('COUNTRIES.FJ') }, { id: 73, name: $translate.instant('COUNTRIES.FI') }, { id: 74, name: $translate.instant('COUNTRIES.FR') }, { id: 75, name: $translate.instant('COUNTRIES.GF') }, { id: 76, name: $translate.instant('COUNTRIES.PF') }, { id: 77, name: $translate.instant('COUNTRIES.TF') }, { id: 78, name: $translate.instant('COUNTRIES.GA') }, { id: 79, name: $translate.instant('COUNTRIES.GM') }, { id: 80, name: $translate.instant('COUNTRIES.GE') }, { id: 81, name: $translate.instant('COUNTRIES.DE') }, { id: 82, name: $translate.instant('COUNTRIES.GH') }, { id: 83, name: $translate.instant('COUNTRIES.GI') }, { id: 84, name: $translate.instant('COUNTRIES.GR') }, { id: 85, name: $translate.instant('COUNTRIES.GL') }, { id: 86, name: $translate.instant('COUNTRIES.GD') }, { id: 87, name: $translate.instant('COUNTRIES.GP') }, { id: 88, name: $translate.instant('COUNTRIES.GU') }, { id: 89, name: $translate.instant('COUNTRIES.GT') }, { id: 90, name: $translate.instant('COUNTRIES.GG') }, { id: 91, name: $translate.instant('COUNTRIES.GN') }, { id: 92, name: $translate.instant('COUNTRIES.GW') }, { id: 93, name: $translate.instant('COUNTRIES.GY') }, { id: 94, name: $translate.instant('COUNTRIES.HT') }, { id: 95, name: $translate.instant('COUNTRIES.HM') }, { id: 96, name: $translate.instant('COUNTRIES.VA') }, { id: 97, name: $translate.instant('COUNTRIES.HN') }, { id: 98, name: $translate.instant('COUNTRIES.HK') }, { id: 99, name: $translate.instant('COUNTRIES.HU') }, { id: 100, name: $translate.instant('COUNTRIES.IS') }, { id: 101, name: $translate.instant('COUNTRIES.IN') }, { id: 102, name: $translate.instant('COUNTRIES.ID') }, { id: 103, name: $translate.instant('COUNTRIES.IR') }, { id: 104, name: $translate.instant('COUNTRIES.IQ') }, { id: 105, name: $translate.instant('COUNTRIES.IE') }, { id: 106, name: $translate.instant('COUNTRIES.IM') }, { id: 107, name: $translate.instant('COUNTRIES.IL') }, { id: 108, name: $translate.instant('COUNTRIES.IT') }, { id: 109, name: $translate.instant('COUNTRIES.JM') }, { id: 110, name: $translate.instant('COUNTRIES.JP') }, { id: 111, name: $translate.instant('COUNTRIES.JE') }, { id: 112, name: $translate.instant('COUNTRIES.JO') }, { id: 113, name: $translate.instant('COUNTRIES.KZ') }, { id: 114, name: $translate.instant('COUNTRIES.KE') }, { id: 115, name: $translate.instant('COUNTRIES.KI') }, { id: 116, name: $translate.instant('COUNTRIES.KP') }, { id: 117, name: $translate.instant('COUNTRIES.KR') }, { id: 118, name: $translate.instant('COUNTRIES.KW') }, { id: 119, name: $translate.instant('COUNTRIES.KG') }, { id: 120, name: $translate.instant('COUNTRIES.LA') }, { id: 121, name: $translate.instant('COUNTRIES.LV') }, { id: 122, name: $translate.instant('COUNTRIES.LB') }, { id: 123, name: $translate.instant('COUNTRIES.LS') }, { id: 124, name: $translate.instant('COUNTRIES.LR') }, { id: 125, name: $translate.instant('COUNTRIES.LY') }, { id: 126, name: $translate.instant('COUNTRIES.LI') }, { id: 127, name: $translate.instant('COUNTRIES.LT') }, { id: 128, name: $translate.instant('COUNTRIES.LU') }, { id: 129, name: $translate.instant('COUNTRIES.MO') }, { id: 130, name: $translate.instant('COUNTRIES.MK') }, { id: 131, name: $translate.instant('COUNTRIES.MG') }, { id: 132, name: $translate.instant('COUNTRIES.MW') }, { id: 133, name: $translate.instant('COUNTRIES.MY') }, { id: 134, name: $translate.instant('COUNTRIES.MV') }, { id: 135, name: $translate.instant('COUNTRIES.ML') }, { id: 136, name: $translate.instant('COUNTRIES.MT') }, { id: 137, name: $translate.instant('COUNTRIES.MH') }, { id: 138, name: $translate.instant('COUNTRIES.MQ') }, { id: 139, name: $translate.instant('COUNTRIES.MR') }, { id: 140, name: $translate.instant('COUNTRIES.MU') }, { id: 141, name: $translate.instant('COUNTRIES.YT') }, { id: 142, name: $translate.instant('COUNTRIES.MX') }, { id: 143, name: $translate.instant('COUNTRIES.FM') }, { id: 144, name: $translate.instant('COUNTRIES.MD') }, { id: 145, name: $translate.instant('COUNTRIES.MC') }, { id: 146, name: $translate.instant('COUNTRIES.MN') }, { id: 147, name: $translate.instant('COUNTRIES.MS') }, { id: 148, name: $translate.instant('COUNTRIES.MA') }, { id: 149, name: $translate.instant('COUNTRIES.MZ') }, { id: 150, name: $translate.instant('COUNTRIES.MM') }, { id: 151, name: $translate.instant('COUNTRIES.NA') }, { id: 152, name: $translate.instant('COUNTRIES.NR') }, { id: 153, name: $translate.instant('COUNTRIES.NP') }, { id: 154, name: $translate.instant('COUNTRIES.NL') }, { id: 155, name: $translate.instant('COUNTRIES.AN') }, { id: 156, name: $translate.instant('COUNTRIES.NC') }, { id: 157, name: $translate.instant('COUNTRIES.NZ') }, { id: 158, name: $translate.instant('COUNTRIES.NI') }, { id: 159, name: $translate.instant('COUNTRIES.NE') }, { id: 160, name: $translate.instant('COUNTRIES.NG') }, { id: 161, name: $translate.instant('COUNTRIES.NU') }, { id: 162, name: $translate.instant('COUNTRIES.NF') }, { id: 163, name: $translate.instant('COUNTRIES.MP') }, { id: 164, name: $translate.instant('COUNTRIES.NO') }, { id: 165, name: $translate.instant('COUNTRIES.OM') }, { id: 166, name: $translate.instant('COUNTRIES.PK') }, { id: 167, name: $translate.instant('COUNTRIES.PW') }, { id: 168, name: $translate.instant('COUNTRIES.PS') }, { id: 169, name: $translate.instant('COUNTRIES.PA') }, { id: 170, name: $translate.instant('COUNTRIES.PG') }, { id: 171, name: $translate.instant('COUNTRIES.PY') }, { id: 172, name: $translate.instant('COUNTRIES.PE') }, { id: 173, name: $translate.instant('COUNTRIES.PH') }, { id: 174, name: $translate.instant('COUNTRIES.PN') }, { id: 175, name: $translate.instant('COUNTRIES.PL') }, { id: 176, name: $translate.instant('COUNTRIES.PT') }, { id: 177, name: $translate.instant('COUNTRIES.PR') }, { id: 178, name: $translate.instant('COUNTRIES.QA') }, { id: 179, name: $translate.instant('COUNTRIES.RE') }, { id: 180, name: $translate.instant('COUNTRIES.RO') }, { id: 181, name: $translate.instant('COUNTRIES.RU') }, { id: 182, name: $translate.instant('COUNTRIES.RW') }, { id: 183, name: $translate.instant('COUNTRIES.SH') }, { id: 184, name: $translate.instant('COUNTRIES.KN') }, { id: 185, name: $translate.instant('COUNTRIES.LC') }, { id: 186, name: $translate.instant('COUNTRIES.PM') }, { id: 187, name: $translate.instant('COUNTRIES.VC') }, { id: 188, name: $translate.instant('COUNTRIES.WS') }, { id: 189, name: $translate.instant('COUNTRIES.SM') }, { id: 190, name: $translate.instant('COUNTRIES.ST') }, { id: 191, name: $translate.instant('COUNTRIES.SA') }, { id: 192, name: $translate.instant('COUNTRIES.SN') }, { id: 193, name: $translate.instant('COUNTRIES.CS') }, { id: 194, name: $translate.instant('COUNTRIES.SC') }, { id: 195, name: $translate.instant('COUNTRIES.SL') }, { id: 196, name: $translate.instant('COUNTRIES.SG') }, { id: 197, name: $translate.instant('COUNTRIES.SK') }, { id: 198, name: $translate.instant('COUNTRIES.SI') }, { id: 199, name: $translate.instant('COUNTRIES.SB') }, { id: 200, name: $translate.instant('COUNTRIES.SO') }, { id: 201, name: $translate.instant('COUNTRIES.ZA') }, { id: 202, name: $translate.instant('COUNTRIES.GS') }, { id: 203, name: $translate.instant('COUNTRIES.ES') }, { id: 204, name: $translate.instant('COUNTRIES.LK') }, { id: 205, name: $translate.instant('COUNTRIES.SD') }, { id: 206, name: $translate.instant('COUNTRIES.SR') }, { id: 207, name: $translate.instant('COUNTRIES.SJ') }, { id: 208, name: $translate.instant('COUNTRIES.SZ') }, { id: 209, name: $translate.instant('COUNTRIES.SE') }, { id: 210, name: $translate.instant('COUNTRIES.CH') }, { id: 211, name: $translate.instant('COUNTRIES.SY') }, { id: 212, name: $translate.instant('COUNTRIES.TW') }, { id: 213, name: $translate.instant('COUNTRIES.TJ') }, { id: 214, name: $translate.instant('COUNTRIES.TZ') }, { id: 215, name: $translate.instant('COUNTRIES.TH') }, { id: 216, name: $translate.instant('COUNTRIES.TL') }, { id: 217, name: $translate.instant('COUNTRIES.TG') }, { id: 218, name: $translate.instant('COUNTRIES.TK') }, { id: 219, name: $translate.instant('COUNTRIES.TO') }, { id: 220, name: $translate.instant('COUNTRIES.TT') }, { id: 221, name: $translate.instant('COUNTRIES.TN') }, { id: 222, name: $translate.instant('COUNTRIES.TR') }, { id: 223, name: $translate.instant('COUNTRIES.TM') }, { id: 224, name: $translate.instant('COUNTRIES.TC') }, { id: 225, name: $translate.instant('COUNTRIES.TV') }, { id: 226, name: $translate.instant('COUNTRIES.UG') }, { id: 227, name: $translate.instant('COUNTRIES.UA') }, { id: 228, name: $translate.instant('COUNTRIES.AE') }, { id: 229, name: $translate.instant('COUNTRIES.GB') }, { id: 230, name: $translate.instant('COUNTRIES.US') }, { id: 231, name: $translate.instant('COUNTRIES.UM') }, { id: 232, name: $translate.instant('COUNTRIES.UY') }, { id: 233, name: $translate.instant('COUNTRIES.UZ') }, { id: 234, name: $translate.instant('COUNTRIES.VU') }, { id: 235, name: $translate.instant('COUNTRIES.VE') }, { id: 236, name: $translate.instant('COUNTRIES.VN') }, { id: 237, name: $translate.instant('COUNTRIES.VG') }, { id: 238, name: $translate.instant('COUNTRIES.VI') }, { id: 239, name: $translate.instant('COUNTRIES.WF') }, { id: 240, name: $translate.instant('COUNTRIES.EH') }, { id: 241, name: $translate.instant('COUNTRIES.YE') }, { id: 242, name: $translate.instant('COUNTRIES.ZM') }, { id: 243, name: $translate.instant('COUNTRIES.ZW') }];
  cov_aer4v9vw8.s[23]++;
  $scope.changeMonth = function () {
    cov_aer4v9vw8.f[7]++;
    cov_aer4v9vw8.s[24]++;

    $scope.listFiscalYears = $deltadate.getPeriods($scope.selectedItem.DATE_DEB_PROJET, $scope.selectedItem.DATE_FIN_PROJET, 1, false, $scope.selectedItem.START_MONTH.index);
    cov_aer4v9vw8.s[25]++;
    for (var _iterator = $scope.listFiscalYears, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var year = _ref;

      var _ = (cov_aer4v9vw8.s[26]++, (cov_aer4v9vw8.b[1][0]++, $scope.listPeriodCutting[year.year]) || (cov_aer4v9vw8.b[1][1]++, { id: 0, period: '0' }));
      cov_aer4v9vw8.s[27]++;
      year.id = _.id;
      cov_aer4v9vw8.s[28]++;
      year.period = $filter('filter')($scope.listPeriodicity, { id: _.period }, true)[0];
    }
  };
  cov_aer4v9vw8.s[29]++;
  $scope.listPeriodicity = [{
    label: $translate.instant('COMMON.YEAR'),
    id: '1'
  }, {
    label: $translate.instant('COMMON.SEM'),
    id: '2'
  }, {
    label: $translate.instant('COMMON.TRIM'),
    id: '4'
  }, {
    label: $translate.instant('COMMON.MOIS'),
    id: '12'
  }, {
    label: '',
    id: '0'
  }];

  cov_aer4v9vw8.s[30]++;
  $scope.contries.sort(function (a, b) {
    cov_aer4v9vw8.f[8]++;
    cov_aer4v9vw8.s[31]++;

    if (a.name > b.name) {
      cov_aer4v9vw8.b[2][0]++;
      cov_aer4v9vw8.s[32]++;

      return 1;
    } else {
      cov_aer4v9vw8.b[2][1]++;
    }
    cov_aer4v9vw8.s[33]++;
    if (a.name < b.name) {
      cov_aer4v9vw8.b[3][0]++;
      cov_aer4v9vw8.s[34]++;

      return -1;
    } else {
      cov_aer4v9vw8.b[3][1]++;
    }
    cov_aer4v9vw8.s[35]++;
    return 0;
  });

  cov_aer4v9vw8.s[36]++;
  $scope.doughnutOptions = {
    segmentShowStroke: true,
    segmentStrokeColor: '#fff',
    segmentStrokeWidth: 2,
    percentageInnerCutout: 45,
    animationSteps: 100,
    animationEasing: 'easeOutBounce',
    animateRotate: true,
    animateScale: false
  };
  cov_aer4v9vw8.s[37]++;
  $scope.error = {};
  cov_aer4v9vw8.s[38]++;
  $scope.listPrograms = [];
  cov_aer4v9vw8.s[39]++;
  $scope.view.activeOnglet = 0;
  cov_aer4v9vw8.s[40]++;
  $scope.statutsList = [{ id: 1, name: $translate.instant('PROJECT.STATUTS.NOT_STARTED') }, { id: 2, name: $translate.instant('PROJECT.STATUTS.ACTIVE') }, { id: 3, name: $translate.instant('PROJECT.STATUTS.SUSPENDED') }, { id: 4, name: $translate.instant('PROJECT.STATUTS.COMPLETED') }, { id: 5, name: $translate.instant('PROJECT.STATUTS.ARCHIVED') }];

  cov_aer4v9vw8.s[41]++;
  $scope.getAll = function () {
    cov_aer4v9vw8.f[9]++;

    var toda = (cov_aer4v9vw8.s[42]++, Date.newDate());

    var idPortfolio = (cov_aer4v9vw8.s[43]++, localStorage.getItem('PORTFOLIO_ID_KEY'));
    cov_aer4v9vw8.s[44]++;
    $scope.isloading = true;
    cov_aer4v9vw8.s[45]++;
    $CRUDService.getAll($scope.PATH, { get: 'portfolio-single', id: idPortfolio }, function (data_) {
      cov_aer4v9vw8.f[10]++;

      var data = (cov_aer4v9vw8.s[46]++, data_.length == 0 ? (cov_aer4v9vw8.b[4][0]++, null) : (cov_aer4v9vw8.b[4][1]++, data_[0]));
      var date = (cov_aer4v9vw8.s[47]++, Date.newDate());
      cov_aer4v9vw8.s[48]++;
      date.setMonth(date.getMonth() + 120);
      cov_aer4v9vw8.s[49]++;
      if (data == null) {
        cov_aer4v9vw8.b[5][0]++;
        cov_aer4v9vw8.s[50]++;

        data = {
          ID_PROGRAM: 0,
          PORTFOLIO: 1,
          ADR_PROJET: '',
          AG_EXE_PROJET: '',
          CODE_ESPACE: '',
          CODE_PRJ: '__________',
          DATE_DEB_PROJET: Date.newDate(),
          DATE_FIN_PROJET: date,
          DESCRIPTION_PROJET: '',
          Format_cout: '',
          ID_LOG_FRAME: 0,
          LIBELLE_PROJET: '',
          PAYS_PROJET: $scope.contries[0].id,
          LINK_PG: false,
          FAX_PROJET: '',
          EMAIL_PROJET: '',
          TEL_PROJET: '',
          id: 0,
          OBJECTIF: '',
          INDICATOR_FIELD_1: '',
          INDICATOR_FIELD_2: '',
          CIBLE: '',
          ZONE: '',
          STATUT: 0,
          STATUS: $scope.statutsList[1].id,
          DATE_MI_PRO: Date.newDate(),
          FINAN: '',
          COUT: 0,
          IDS_AGENCY: [],
          STATUT_BUDGET: false,
          ID_AGENCY: 0,
          CROSS_CUTTING_KPIS: false,
          PORTFOLIO_CROSS_CUTTING_KPIS: true,
          CUSTOM_FIELD: false,
          MISSIONS: false,
          RISK: false,
          PROBLEM: false,
          ACTIVE_SMS: false,
          LINK: {
            U: 0,
            SF: 0,
            PG: 0,
            PL: 0,
            F: 0,
            TA: 0,
            TI: 0,
            TR: 0,
            FR: 0
          },
          PERIODIC_FOLLOW: $scope.listPeriodicity[0].id,
          ME_METHOD: $scope.listOptionSEMethods[0].id,
          START_MONTH: $scope.listMonths[0].id,
          GLOBAL_PLAN: 0,
          ACTIVITY_WEIGHT: 0,
          ACTIVITY_WEIGHT_AN: 0,
          DISPLAY_DATA: 0
        };
      } else {
        cov_aer4v9vw8.b[5][1]++;
        cov_aer4v9vw8.s[51]++;

        data.img = $deltahttp.getProjectRepository(data.id, Date.newDate());
        cov_aer4v9vw8.s[52]++;
        data.DATE_DEB_PROJET = Date.newDate(data.DATE_DEB_PROJET);
        cov_aer4v9vw8.s[53]++;
        data.COUT = eval(data.COUT);
        cov_aer4v9vw8.s[54]++;
        data.CROSS_CUTTING_KPIS = data.CROSS_CUTTING_KPIS == 1;
        cov_aer4v9vw8.s[55]++;
        data.PORTFOLIO_CROSS_CUTTING_KPIS = data.PORTFOLIO_CROSS_CUTTING_KPIS == 1;
        cov_aer4v9vw8.s[56]++;
        data.CUSTOM_FIELD = data.CUSTOM_FIELD == 1;
        cov_aer4v9vw8.s[57]++;
        data.MISSIONS = data.MISSIONS == 1;
        cov_aer4v9vw8.s[58]++;
        data.RISK = data.RISK == 1;
        cov_aer4v9vw8.s[59]++;
        data.PROBLEM = data.PROBLEM == 1;
        cov_aer4v9vw8.s[60]++;
        data.ACTIVE_SMS = data.ACTIVE_SMS == 1;

        cov_aer4v9vw8.s[61]++;
        data.STATUT_BUDGET = parseInt(data.STATUT_BUDGET, 10) === 1;
        cov_aer4v9vw8.s[62]++;
        data.DATE_FIN_PROJET = Date.newDate(data.DATE_FIN_PROJET);
        cov_aer4v9vw8.s[63]++;
        data.DATE_MI_PRO = Date.newDate((cov_aer4v9vw8.b[6][0]++, data.DATE_MI_PRO) || (cov_aer4v9vw8.b[6][1]++, undefined));

        var diff = (cov_aer4v9vw8.s[64]++, data.DATE_FIN_PROJET - data.DATE_DEB_PROJET);
        cov_aer4v9vw8.s[65]++;
        data.progress = 0;
        cov_aer4v9vw8.s[66]++;
        if (diff != 0) {
          cov_aer4v9vw8.b[7][0]++;
          cov_aer4v9vw8.s[67]++;

          data.progress = Math.min((toda - data.DATE_DEB_PROJET) / diff * 100, 100);
        } else {
          cov_aer4v9vw8.b[7][1]++;
        }
        cov_aer4v9vw8.s[68]++;
        if (data.progress < 0) {
          cov_aer4v9vw8.b[8][0]++;
          cov_aer4v9vw8.s[69]++;

          data.progress = 0;
        } else {
          cov_aer4v9vw8.b[8][1]++;
        }
        cov_aer4v9vw8.s[70]++;
        data.PAYS_PROJET = parseInt(data.PAYS_PROJET, 10);
        cov_aer4v9vw8.s[71]++;
        data.PAYS = $filter('filter')($scope.contries, { id: data.PAYS_PROJET }, true)[0];

        cov_aer4v9vw8.s[72]++;
        data.progress = {
          data: [{
            value: data.progress,
            highlight: '#1ab394',
            label: '',
            color: '#1ab394'

          }, {
            value: 100 - data.progress,
            highlight: '#d7d7d7',
            label: '',
            color: '#d7d7d7'
          }]
        };
      }
      cov_aer4v9vw8.s[73]++;
      $scope.edit(data);
    });
  };

  cov_aer4v9vw8.s[74]++;
  $scope.selectedItem = {};
  cov_aer4v9vw8.s[75]++;
  $scope.cancel = function () {
    cov_aer4v9vw8.f[11]++;
    cov_aer4v9vw8.s[76]++;

    $rootScope.goToPrevious();
  };
  cov_aer4v9vw8.s[77]++;
  $scope.validate = function () {
    cov_aer4v9vw8.f[12]++;

    var validateItem = (cov_aer4v9vw8.s[78]++, angular.copy($scope.selectedItem));
    cov_aer4v9vw8.s[79]++;
    validateItem.DATE_DEB_PROJET = $deltadate.format($scope.selectedItem.DATE_DEB_PROJET, 'dd/mm/yyyy');
    cov_aer4v9vw8.s[80]++;
    validateItem.DATE_FIN_PROJET = $deltadate.format($scope.selectedItem.DATE_FIN_PROJET, 'dd/mm/yyyy');
    cov_aer4v9vw8.s[81]++;
    validateItem.DATE_MI_PRO = $deltadate.format($scope.selectedItem.DATE_MI_PRO, 'yyyy-mm-dd');
    cov_aer4v9vw8.s[82]++;
    validateItem.PAYS_PROJET = $scope.selectedItem.PAYS_PROJET.id;
    cov_aer4v9vw8.s[83]++;
    validateItem.ID_AGENCY = 0;cov_aer4v9vw8.s[84]++;

    validateItem.IDS_AGENCY = $scope.selectedItem.IDS_AGENCY.map(function (value) {
      cov_aer4v9vw8.f[13]++;
      cov_aer4v9vw8.s[85]++;
      return value.id;
    });
    cov_aer4v9vw8.s[86]++;
    validateItem.STATUT_BUDGET = (cov_aer4v9vw8.b[10][0]++, $scope.selectedItem.DISPLAY_DATA) && (cov_aer4v9vw8.b[10][1]++, $scope.selectedItem.STATUT_BUDGET) ? (cov_aer4v9vw8.b[9][0]++, 1) : (cov_aer4v9vw8.b[9][1]++, 0);
    cov_aer4v9vw8.s[87]++;
    validateItem.STATUS = $scope.selectedItem.STATUS.id;
    cov_aer4v9vw8.s[88]++;
    validateItem.GLOBAL_PLAN = $scope.selectedItem.GLOBAL_PLAN ? (cov_aer4v9vw8.b[11][0]++, 1) : (cov_aer4v9vw8.b[11][1]++, 0);
    cov_aer4v9vw8.s[89]++;
    validateItem.ACTIVITY_WEIGHT = $scope.selectedItem.ACTIVITY_WEIGHT ? (cov_aer4v9vw8.b[12][0]++, 1) : (cov_aer4v9vw8.b[12][1]++, 0);
    cov_aer4v9vw8.s[90]++;
    validateItem.ACTIVITY_WEIGHT_AN = (cov_aer4v9vw8.b[14][0]++, $scope.selectedItem.ACTIVITY_WEIGHT) && (cov_aer4v9vw8.b[14][1]++, $scope.selectedItem.ACTIVITY_WEIGHT_AN) ? (cov_aer4v9vw8.b[13][0]++, 1) : (cov_aer4v9vw8.b[13][1]++, 0);
    cov_aer4v9vw8.s[91]++;
    validateItem.DISPLAY_DATA = $scope.selectedItem.DISPLAY_DATA ? (cov_aer4v9vw8.b[15][0]++, 1) : (cov_aer4v9vw8.b[15][1]++, 0);

    cov_aer4v9vw8.s[92]++;
    validateItem.CROSS_CUTTING_KPIS = $scope.selectedItem.CROSS_CUTTING_KPIS ? (cov_aer4v9vw8.b[16][0]++, 1) : (cov_aer4v9vw8.b[16][1]++, 0);
    cov_aer4v9vw8.s[93]++;
    validateItem.PORTFOLIO_CROSS_CUTTING_KPIS = $scope.selectedItem.PORTFOLIO_CROSS_CUTTING_KPIS ? (cov_aer4v9vw8.b[17][0]++, 1) : (cov_aer4v9vw8.b[17][1]++, 0);
    cov_aer4v9vw8.s[94]++;
    validateItem.CUSTOM_FIELD = $scope.selectedItem.CUSTOM_FIELD ? (cov_aer4v9vw8.b[18][0]++, 1) : (cov_aer4v9vw8.b[18][1]++, 0);
    cov_aer4v9vw8.s[95]++;
    validateItem.MISSIONS = $scope.selectedItem.MISSIONS ? (cov_aer4v9vw8.b[19][0]++, 1) : (cov_aer4v9vw8.b[19][1]++, 0);
    cov_aer4v9vw8.s[96]++;
    validateItem.RISK = $scope.selectedItem.RISK ? (cov_aer4v9vw8.b[20][0]++, 1) : (cov_aer4v9vw8.b[20][1]++, 0);
    cov_aer4v9vw8.s[97]++;
    validateItem.PROBLEM = $scope.selectedItem.PROBLEM ? (cov_aer4v9vw8.b[21][0]++, 1) : (cov_aer4v9vw8.b[21][1]++, 0);
    cov_aer4v9vw8.s[98]++;
    validateItem.ACTIVE_SMS = $scope.selectedItem.ACTIVE_SMS ? (cov_aer4v9vw8.b[22][0]++, 1) : (cov_aer4v9vw8.b[22][1]++, 0);
    cov_aer4v9vw8.s[99]++;
    validateItem.ACTIVE_SUP = $scope.selectedItem.ACTIVE_SUP ? (cov_aer4v9vw8.b[23][0]++, 1) : (cov_aer4v9vw8.b[23][1]++, 0);

    cov_aer4v9vw8.s[100]++;
    validateItem.LINK_PG = $scope.selectedItem.LINK_PG ? (cov_aer4v9vw8.b[24][0]++, 1) : (cov_aer4v9vw8.b[24][1]++, 0);
    cov_aer4v9vw8.s[101]++;
    validateItem.PERIODIC_FOLLOW = 1;cov_aer4v9vw8.s[102]++;

    validateItem.ME_METHOD = 2;cov_aer4v9vw8.s[103]++;

    validateItem.ID_LOG_FRAME = $scope.selectedItem.ID_LOG_FRAME.id;cov_aer4v9vw8.s[104]++;

    validateItem.START_MONTH = $scope.selectedItem.START_MONTH.index;

    cov_aer4v9vw8.s[105]++;
    validateItem.LINK = {
      U: $scope.selectedItem.LINK.U ? (cov_aer4v9vw8.b[25][0]++, '1') : (cov_aer4v9vw8.b[25][1]++, '0'),
      SF: $scope.selectedItem.LINK.SF ? (cov_aer4v9vw8.b[26][0]++, '1') : (cov_aer4v9vw8.b[26][1]++, '0'),
      PG: $scope.selectedItem.LINK.PG ? (cov_aer4v9vw8.b[27][0]++, '1') : (cov_aer4v9vw8.b[27][1]++, '0'),
      PL: $scope.selectedItem.LINK.PL ? (cov_aer4v9vw8.b[28][0]++, '1') : (cov_aer4v9vw8.b[28][1]++, '0'),
      F: $scope.selectedItem.LINK.F ? (cov_aer4v9vw8.b[29][0]++, '1') : (cov_aer4v9vw8.b[29][1]++, '0'),
      TA: $scope.selectedItem.LINK.TA ? (cov_aer4v9vw8.b[30][0]++, '1') : (cov_aer4v9vw8.b[30][1]++, '0'),
      TI: $scope.selectedItem.LINK.TI ? (cov_aer4v9vw8.b[31][0]++, '1') : (cov_aer4v9vw8.b[31][1]++, '0'),
      TR: $scope.selectedItem.LINK.TR ? (cov_aer4v9vw8.b[32][0]++, '1') : (cov_aer4v9vw8.b[32][1]++, '0'),
      FR: $scope.selectedItem.LINK.FR ? (cov_aer4v9vw8.b[33][0]++, '1') : (cov_aer4v9vw8.b[33][1]++, '0')
    };
    cov_aer4v9vw8.s[106]++;
    $scope.error = {
      id: 0,
      label: null
    };
    cov_aer4v9vw8.s[107]++;

    for (var i = 0; i < $scope.listProjects.length; i++) {
      var item = (cov_aer4v9vw8.s[108]++, $scope.listProjects[i]);
      cov_aer4v9vw8.s[109]++;
      if ($scope.listProjects[i].id == item.id) {
        cov_aer4v9vw8.b[34][0]++;
        cov_aer4v9vw8.s[110]++;

        if ((cov_aer4v9vw8.b[36][0]++, item.id != validateItem.id) && (cov_aer4v9vw8.b[36][1]++, validateItem.CODE_PRJ == item.CODE_PRJ)) {
          cov_aer4v9vw8.b[35][0]++;
          cov_aer4v9vw8.s[111]++;

          $scope.error = {
            id: 1,
            label: 'PROJECT.ERROR.DBL'
          };
          cov_aer4v9vw8.s[112]++;
          $scope.edit.tab = 1;
          cov_aer4v9vw8.s[113]++;
          return;
        } else {
          cov_aer4v9vw8.b[35][1]++;
        }
      } else {
        cov_aer4v9vw8.b[34][1]++;
      }
    }
    cov_aer4v9vw8.s[114]++;
    if ($scope.selectedItem.DATE_DEB_PROJET > $scope.selectedItem.DATE_FIN_PROJET) {
      cov_aer4v9vw8.b[37][0]++;
      cov_aer4v9vw8.s[115]++;

      $scope.error = {
        id: 2,
        label: 'PROJECT.ERROR.DATE'
      };
      cov_aer4v9vw8.s[116]++;
      $scope.edit.tab = 1;
      cov_aer4v9vw8.s[117]++;
      return;
    } else {
      cov_aer4v9vw8.b[37][1]++;
    }
    cov_aer4v9vw8.s[118]++;
    if (validateItem.Format_cout.length > 5) {
      cov_aer4v9vw8.b[38][0]++;
      cov_aer4v9vw8.s[119]++;

      $scope.error = {
        id: 3,
        label: 'PROJECT.ERROR.CURRENCY'
      };
      cov_aer4v9vw8.s[120]++;
      $scope.edit.tab = 1;
      cov_aer4v9vw8.s[121]++;
      return;
    } else {
      cov_aer4v9vw8.b[38][1]++;
    }

    cov_aer4v9vw8.s[122]++;
    validateItem.img = undefined;
    cov_aer4v9vw8.s[123]++;
    validateItem.progress = undefined;

    cov_aer4v9vw8.s[124]++;
    if ((cov_aer4v9vw8.b[40][0]++, $scope.LAST_START_MONTH != validateItem.START_MONTH) && (cov_aer4v9vw8.b[40][1]++, validateItem.id != 0)) {
      cov_aer4v9vw8.b[39][0]++;
      cov_aer4v9vw8.s[125]++;

      SweetAlert.swal({
        title: '',
        text: $translate.instant('PROJECT.ERROR.SAVING'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55', cancelButtonColor: '#c8c8c8',
        confirmButtonText: $translate.instant('COMMON.CANCEL'),
        cancelButtonText: $translate.instant('COMMON.CONTINUE'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_aer4v9vw8.f[14]++;
        cov_aer4v9vw8.s[126]++;

        if (isconfirm) {
          cov_aer4v9vw8.b[41][0]++;
          cov_aer4v9vw8.s[127]++;

          return;
        } else {
          cov_aer4v9vw8.b[41][1]++;
        }
        cov_aer4v9vw8.s[128]++;
        $scope.__saveProject(validateItem);
      });
    } else {
      cov_aer4v9vw8.b[39][1]++;
      cov_aer4v9vw8.s[129]++;

      $scope.__saveProject(validateItem);
    }
    cov_aer4v9vw8.s[130]++;
    $state.go('index.projects');
  };

  cov_aer4v9vw8.s[131]++;
  $scope.changeActivateSms = function () {
    cov_aer4v9vw8.f[15]++;
    cov_aer4v9vw8.s[132]++;

    if ($scope.selectedItem.ACTIVE_SMS) {
      cov_aer4v9vw8.b[42][0]++;
      cov_aer4v9vw8.s[133]++;

      SweetAlert.swal({
        title: $translate.instant('PROJECT.ACTIVE_SMS_WARNING'),

        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#c8c8c8',
        cancelButtonText: $translate.instant('COMMON.YES'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        cov_aer4v9vw8.f[16]++;
        cov_aer4v9vw8.s[134]++;

        if (isConfirm) {
          cov_aer4v9vw8.b[43][0]++;
          cov_aer4v9vw8.s[135]++;

          return;
        } else {
          cov_aer4v9vw8.b[43][1]++;
        }
      });
    } else {
      cov_aer4v9vw8.b[42][1]++;
    }
  };

  cov_aer4v9vw8.s[136]++;
  $CRUDService.getAll($scope.PATH, { get: 'devises' }, function (_data2) {
    cov_aer4v9vw8.f[17]++;
    cov_aer4v9vw8.s[137]++;

    $scope.autoCompleteGroupOptions = {
      minimumChars: 0,
      containerCssClass: 'white-bg',
      selectedCssClass: 'selected-item-auto-complete',
      noMatchTemplateEnabled: false,
      activateOnFocus: true,
      data: function data(searchText) {
        cov_aer4v9vw8.s[138]++;

        return _data2;
      }
    };
  });
  cov_aer4v9vw8.s[139]++;
  $scope.__saveProject = function (validateItem) {
    cov_aer4v9vw8.f[18]++;

    var valueP = (cov_aer4v9vw8.s[140]++, $filter('json')(validateItem, 3));
    cov_aer4v9vw8.s[141]++;
    $scope.isloading = true;
    cov_aer4v9vw8.s[142]++;
    $CRUDService.save($scope.PATH, { action: 'miseAJourAdmin', valeur: validateItem }, function (result) {
      cov_aer4v9vw8.f[19]++;

      var data = (cov_aer4v9vw8.s[143]++, parseInt(result, 10));
      cov_aer4v9vw8.s[144]++;
      if (data > 0) {
        cov_aer4v9vw8.b[44][0]++;
        cov_aer4v9vw8.s[145]++;

        for (var _iterator2 = $scope.addingSource, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
          var _ref2;

          if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
          } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
          }

          var source = _ref2;
          cov_aer4v9vw8.s[146]++;

          $CRUDService.save('Financement', { action: 'MiseAJourProjet', valeur: $filter('json')(source), id: data });
        }
        cov_aer4v9vw8.s[147]++;
        for (var _iterator3 = (cov_aer4v9vw8.b[45][0]++, $scope.deletedMilestone) || (cov_aer4v9vw8.b[45][1]++, []), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
          } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
          }

          var id = _ref3;
          cov_aer4v9vw8.s[148]++;

          $CRUDService.delet(PATH, { action: 'supp', id: id });
        }
        cov_aer4v9vw8.s[149]++;
        for (var _iterator4 = $scope.listMilestone, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
          var _ref4;

          if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
          } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
          }

          var milestone = _ref4;
          cov_aer4v9vw8.s[150]++;

          milestone.ID_PROJET = data;
          cov_aer4v9vw8.s[151]++;
          milestone.REALIZE = milestone.REALIZE ? (cov_aer4v9vw8.b[46][0]++, 1) : (cov_aer4v9vw8.b[46][1]++, 0);
          cov_aer4v9vw8.s[152]++;
          $CRUDService.save(PATH, { action: 'miseAJour', valeur: $filter('json')(milestone) });
        }
        cov_aer4v9vw8.s[153]++;
        for (var _iterator5 = $scope.listFiscalYears, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
          var _ref5;

          if (_isArray5) {
            if (_i5 >= _iterator5.length) break;
            _ref5 = _iterator5[_i5++];
          } else {
            _i5 = _iterator5.next();
            if (_i5.done) break;
            _ref5 = _i5.value;
          }

          var per = _ref5;
          cov_aer4v9vw8.s[154]++;

          $CRUDService.save('Periode', { action: 'save_periode_project', id: data, valeur: $filter('json')({
              ANNEE_PERIOD: per.year,
              DECOUPAGE_PERIOD: per.period.id,
              id: per.id
            }) }, function (_data) {
            cov_aer4v9vw8.f[20]++;
            cov_aer4v9vw8.s[155]++;

            if (_data == -1) {
              cov_aer4v9vw8.b[47][0]++;
              cov_aer4v9vw8.s[156]++;

              return;
            } else {
              cov_aer4v9vw8.b[47][1]++;
            }
          });
        }
      } else {
        cov_aer4v9vw8.b[44][1]++;
      }

      cov_aer4v9vw8.s[157]++;

      if ((cov_aer4v9vw8.b[49][0]++, validateItem.id > 0) && (cov_aer4v9vw8.b[49][1]++, validateItem.ACTIVE_SUP == 0)) {
        cov_aer4v9vw8.b[48][0]++;
        cov_aer4v9vw8.s[158]++;

        $CRUDService.getAll($scope.PATH, { get: 'remove_all_deleted', id: validateItem.id, ACTIVE_SUP: validateItem.ACTIVE_SUP }, function (data_) {
          cov_aer4v9vw8.f[21]++;
        });
      } else {
        cov_aer4v9vw8.b[48][1]++;
      }

      cov_aer4v9vw8.s[159]++;
      $state.go('index.projects');
    });
  };

  cov_aer4v9vw8.s[160]++;
  $scope.edit = function (item) {
    cov_aer4v9vw8.f[22]++;
    cov_aer4v9vw8.s[161]++;

    $scope.isloading = false;
    cov_aer4v9vw8.s[162]++;
    $scope.LAST_START_MONTH = item.START_MONTH;
    cov_aer4v9vw8.s[163]++;
    $scope.addingSource = [];
    cov_aer4v9vw8.s[164]++;
    $scope.edit.tab = 1;
    cov_aer4v9vw8.s[165]++;
    $scope.edit.tabPeriod = 1;
    cov_aer4v9vw8.s[166]++;
    $scope.error_code = false;
    cov_aer4v9vw8.s[167]++;
    $scope.isadd = true;
    cov_aer4v9vw8.s[168]++;
    $scope.selectedItem = angular.copy(item);
    cov_aer4v9vw8.s[169]++;
    $scope.selectedItem.PERIODIC_FOLLOW = $filter('filter')($scope.listPeriodicity, { id: (cov_aer4v9vw8.b[50][0]++, item.PERIODIC_FOLLOW) || (cov_aer4v9vw8.b[50][1]++, '1') }, true)[0];
    cov_aer4v9vw8.s[170]++;
    $scope.selectedItem.STATUS = $filter('filter')($scope.statutsList, { id: (cov_aer4v9vw8.b[51][0]++, parseInt(item.STATUS, 10)) || (cov_aer4v9vw8.b[51][1]++, 1) }, true)[0];

    cov_aer4v9vw8.s[171]++;
    if ((cov_aer4v9vw8.b[53][0]++, $scope.listOptionSEMethods) && (cov_aer4v9vw8.b[53][1]++, $scope.listOptionSEMethods.length > 0)) {
      cov_aer4v9vw8.b[52][0]++;
      cov_aer4v9vw8.s[172]++;

      $scope.selectedItem.ID_LOG_FRAME = $scope.listOptionSEMethods.find(function (value) {
        cov_aer4v9vw8.f[23]++;
        cov_aer4v9vw8.s[173]++;

        return value.id == item.ID_LOG_FRAME;
      });

      cov_aer4v9vw8.s[174]++;
      if (!$scope.selectedItem.ID_LOG_FRAME) {
        cov_aer4v9vw8.b[54][0]++;
        cov_aer4v9vw8.s[175]++;

        $scope.selectedItem.ID_LOG_FRAME = $scope.listOptionSEMethods[$scope.listOptionSEMethods.length - 1];
      } else {
        cov_aer4v9vw8.b[54][1]++;
      }
    } else {
      cov_aer4v9vw8.b[52][1]++;
    }

    cov_aer4v9vw8.s[176]++;
    $scope.selectedItem.ACTIVE_SUP = item.ACTIVE_SUP == 1;
    cov_aer4v9vw8.s[177]++;
    $scope.selectedItem.CHAMP_LIBRE = item.CHAMP_LIBRE == "1";
    cov_aer4v9vw8.s[178]++;
    $scope.selectedItem.OPTIONS_FIXES = item.OPTIONS_FIXES == "1";

    cov_aer4v9vw8.s[179]++;

    $scope.selectedItem.START_MONTH = $filter('filter')($scope.listMonths, { index: parseInt((cov_aer4v9vw8.b[55][0]++, item.START_MONTH) || (cov_aer4v9vw8.b[55][1]++, 1), 10) }, true)[0];
    cov_aer4v9vw8.s[180]++;
    $scope.selectedItem.GLOBAL_PLAN = item.GLOBAL_PLAN == 1;
    cov_aer4v9vw8.s[181]++;
    $scope.selectedItem.ACTIVITY_WEIGHT = item.ACTIVITY_WEIGHT == 1;
    cov_aer4v9vw8.s[182]++;
    $scope.selectedItem.ACTIVITY_WEIGHT_AN = item.ACTIVITY_WEIGHT_AN == 1;
    cov_aer4v9vw8.s[183]++;
    $scope.selectedItem.DISPLAY_DATA = item.DISPLAY_DATA == 1;
    cov_aer4v9vw8.s[184]++;
    $scope.selectedItem.LINK_PG = item.LINK_PG == 1;
    cov_aer4v9vw8.s[185]++;
    $scope.selectedItem.PAYS_PROJET = $filter('filter')($scope.contries, { id: item.PAYS_PROJET }, true)[0];cov_aer4v9vw8.s[186]++;

    $scope.selectedItem.LINK = {
      U: $scope.selectedItem.LINK.U != 0,
      SF: $scope.selectedItem.LINK.SF != 0,
      PG: $scope.selectedItem.LINK.PG != 0,
      PL: $scope.selectedItem.LINK.PL != 0,
      F: $scope.selectedItem.LINK.F != 0,
      TA: $scope.selectedItem.LINK.TA != 0,
      TI: $scope.selectedItem.LINK.TI != 0,
      TR: $scope.selectedItem.LINK.TR != 0,
      FR: $scope.selectedItem.LINK.FR != 0
    };
    cov_aer4v9vw8.s[187]++;
    $scope.selectedItem.IDS_AGENCY = [];
    cov_aer4v9vw8.s[188]++;
    $scope.initialImg = $deltahttp.getProjectRepository($scope.selectedItem.id);
    cov_aer4v9vw8.s[189]++;
    if (item.id) {
      cov_aer4v9vw8.b[56][0]++;
      cov_aer4v9vw8.s[190]++;

      $CRUDService.getAll('NiveauCl', { get: 'count', id: item.id }, function (data) {
        cov_aer4v9vw8.f[24]++;
        cov_aer4v9vw8.s[191]++;

        $scope.blockDelete = parseInt(data, 10) > 0;
      });
    } else {
      cov_aer4v9vw8.b[56][1]++;
    }
    cov_aer4v9vw8.s[192]++;
    $scope.listPeriodCutting = {};
    cov_aer4v9vw8.s[193]++;
    $CRUDService.getAll('Periode', { get: 'all_projet', id: $scope.selectedItem.id }, function (data) {
      cov_aer4v9vw8.f[25]++;
      cov_aer4v9vw8.s[194]++;

      for (var _iterator6 = data, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray6) {
          if (_i6 >= _iterator6.length) break;
          _ref6 = _iterator6[_i6++];
        } else {
          _i6 = _iterator6.next();
          if (_i6.done) break;
          _ref6 = _i6.value;
        }

        var it = _ref6;
        cov_aer4v9vw8.s[195]++;

        $scope.listPeriodCutting[it.ANNEE_PERIOD] = {
          period: it.DECOUPAGE_PERIOD,
          id: it.id
        };
      }
      cov_aer4v9vw8.s[196]++;

      $scope.changeMonth();
    });
    cov_aer4v9vw8.s[197]++;
    $scope.locks = {
      plan_global: false,
      periods: []
    };
    cov_aer4v9vw8.s[198]++;
    $CRUDService.getAll($scope.PATH, { get: 'can_update', id: $scope.selectedItem.id }, function (data) {
      cov_aer4v9vw8.f[26]++;
      cov_aer4v9vw8.s[199]++;

      $scope.locks = data;
    });

    cov_aer4v9vw8.s[200]++;
    $scope.isedit = $scope.selectedItem.id == 0;
    cov_aer4v9vw8.s[201]++;
    $scope.deletedMilestone = [];
    cov_aer4v9vw8.s[202]++;
    $CRUDService.getAll(PATH, { get: 'all', id: (cov_aer4v9vw8.b[57][0]++, item.id) || (cov_aer4v9vw8.b[57][1]++, 0) }, function (data) {
      cov_aer4v9vw8.f[27]++;
      cov_aer4v9vw8.s[203]++;

      for (var _iterator7 = data, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var el = _ref7;
        cov_aer4v9vw8.s[204]++;

        if (el.PLANNED_DATE) {
          cov_aer4v9vw8.b[58][0]++;
          cov_aer4v9vw8.s[205]++;

          el.PLANNED_DATE = Date.newDate(el.PLANNED_DATE);
        } else {
          cov_aer4v9vw8.b[58][1]++;
        }
        cov_aer4v9vw8.s[206]++;
        if (el.ACTUAL_DATE) {
          cov_aer4v9vw8.b[59][0]++;
          cov_aer4v9vw8.s[207]++;

          el.ACTUAL_DATE = Date.newDate(el.ACTUAL_DATE);
        } else {
          cov_aer4v9vw8.b[59][1]++;
        }

        cov_aer4v9vw8.s[208]++;
        el.REALIZE = el.REALIZE == 1;
      }
      cov_aer4v9vw8.s[209]++;
      $scope.listMilestone = data;
    });
  };
  cov_aer4v9vw8.s[210]++;
  $scope.deleteItem = function (item) {
    cov_aer4v9vw8.f[28]++;
    cov_aer4v9vw8.s[211]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_aer4v9vw8.f[29]++;
      cov_aer4v9vw8.s[212]++;

      if (isconfirm) {
        cov_aer4v9vw8.b[60][0]++;
        cov_aer4v9vw8.s[213]++;

        return;
      } else {
        cov_aer4v9vw8.b[60][1]++;
      }
      cov_aer4v9vw8.s[214]++;
      $scope.isloading = true;
      var validateItem = (cov_aer4v9vw8.s[215]++, {
        ADR_PROJET: item.ADR_PROJET,
        AG_EXE_PROJET: item.AG_EXE_PROJET,
        CODE_ESPACE: item.CODE_ESPACE,
        CODE_PRJ: item.CODE_PRJ,
        DESCRIPTION_PROJET: item.DESCRIPTION_PROJET,
        EMAIL_PROJET: item.EMAIL_PROJET,
        DATE_DEB_PROJET: $deltadate.format(item.DATE_DEB_PROJET, 'dd/mm/yyyy'),
        DATE_FIN_PROJET: $deltadate.format(item.DATE_FIN_PROJET, 'dd/mm/yyyy'),
        Format_cout: item.Format_cout,
        LIBELLE_PROJET: item.LIBELLE_PROJET,
        PAYS_PROJET: item.PAYS_PROJET.id,
        TEL_PROJET: item.TEL_PROJET,
        FAX_PROJET: item.FAX_PROJET,

        id: item.id
      });
      cov_aer4v9vw8.s[216]++;
      $CRUDService.delet($scope.PATH, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_aer4v9vw8.f[30]++;
        cov_aer4v9vw8.s[217]++;

        if (data < 0) {
          cov_aer4v9vw8.b[61][0]++;
          cov_aer4v9vw8.s[218]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PROJECT.ERROR.DELETE')
          });
          cov_aer4v9vw8.s[219]++;
          $scope.isloading = false;
          cov_aer4v9vw8.s[220]++;
          return;
        } else {
          cov_aer4v9vw8.b[61][1]++;
        }
        cov_aer4v9vw8.s[221]++;
        $scope.filter.processFilter();
      });
    });
  };

  cov_aer4v9vw8.s[222]++;
  $scope.select = function (projet) {
    cov_aer4v9vw8.f[31]++;

    var selectedProjet = (cov_aer4v9vw8.s[223]++, angular.copy(projet));
    cov_aer4v9vw8.s[224]++;
    $rootScope.setAtHome(false);
    cov_aer4v9vw8.s[225]++;
    $otherHttpService.post($scope.PATH, { action: 'setActive', id: projet.id }, function (data) {
      cov_aer4v9vw8.f[32]++;
      cov_aer4v9vw8.s[226]++;

      $rootScope.setProject({
        project: selectedProjet,
        droit: data.droits,
        connected: data.connect,
        isAdmin: data.isAdmin,
        canAccessAdminPanel: data.canAccessAdminPanel,
        link: data.a,
        admin: data.res,
        profils: data.profils,
        lastLogLevel: data.lL
      });
      cov_aer4v9vw8.s[227]++;
      $deltaclearData.clearData();
      cov_aer4v9vw8.s[228]++;
      $deltaGeoData.__initialise();
      cov_aer4v9vw8.s[229]++;
      $location.path('/app/dashboard').replace();
    });
  };
  cov_aer4v9vw8.s[230]++;
  $scope.addMilestone = function () {
    cov_aer4v9vw8.f[33]++;
    cov_aer4v9vw8.s[231]++;

    $scope.editMilestone({
      id: -Date.newDate().getTime(),
      NAME: '',
      PLANNED_DATE: $deltadate.format(Date.newDate(), 'YYYY-MM-DD'),
      ACTUAL_DATE: $deltadate.format(Date.newDate(), 'YYYY-MM-DD'),
      COMMENTS: '',
      REALIZE: false
    });
  };

  cov_aer4v9vw8.s[232]++;
  $scope.editMilestone = function (item) {
    cov_aer4v9vw8.f[34]++;
    cov_aer4v9vw8.s[233]++;

    $scope.selectedMilestone = angular.copy(item);
    cov_aer4v9vw8.s[234]++;
    $scope.selectedMilestone.PLANNED_DATE = Date.newDate($scope.selectedMilestone.PLANNED_DATE);
    cov_aer4v9vw8.s[235]++;
    $scope.selectedMilestone.ACTUAL_DATE = Date.newDate($scope.selectedMilestone.ACTUAL_DATE);
    cov_aer4v9vw8.s[236]++;

    $uibModal.open({
      templateUrl: 'app/views/project/edit/milestone.html',
      controller: milestone_edit,
      scope: $scope,
      size: 'xs_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
  cov_aer4v9vw8.s[237]++;
  $scope.validateMilestone = function (item) {
    cov_aer4v9vw8.f[35]++;

    var data = (cov_aer4v9vw8.s[238]++, {
      id: item.id,
      NAME: item.NAME,
      PLANNED_DATE: $deltadate.format(item.PLANNED_DATE, 'YYYY-MM-DD'),
      ACTUAL_DATE: $deltadate.format(item.ACTUAL_DATE, 'YYYY-MM-DD'),
      COMMENTS: item.COMMENTS,
      REALIZE: item.REALIZE
    });

    var _d = (cov_aer4v9vw8.s[239]++, $filter('filter')($scope.listMilestone, { id: data.id }, true));
    var index = (cov_aer4v9vw8.s[240]++, $scope.listMilestone.indexOf(_d[0]));
    cov_aer4v9vw8.s[241]++;
    if (index >= 0) {
      cov_aer4v9vw8.b[62][0]++;
      cov_aer4v9vw8.s[242]++;

      $scope.listMilestone[index] = data;
    } else {
      cov_aer4v9vw8.b[62][1]++;
      cov_aer4v9vw8.s[243]++;

      $scope.listMilestone.push(data);
    }
  };

  cov_aer4v9vw8.s[244]++;
  $scope.deleteMilestone = function (item) {
    cov_aer4v9vw8.f[36]++;
    cov_aer4v9vw8.s[245]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_aer4v9vw8.f[37]++;
      cov_aer4v9vw8.s[246]++;

      if (isconfirm) {
        cov_aer4v9vw8.b[63][0]++;
        cov_aer4v9vw8.s[247]++;

        return;
      } else {
        cov_aer4v9vw8.b[63][1]++;
      }
      var index = (cov_aer4v9vw8.s[248]++, $scope.listMilestone.indexOf(item));
      cov_aer4v9vw8.s[249]++;
      if (index >= 0) {
        cov_aer4v9vw8.b[64][0]++;
        cov_aer4v9vw8.s[250]++;

        if (item.id > 0) {
          cov_aer4v9vw8.b[65][0]++;
          cov_aer4v9vw8.s[251]++;

          $scope.deletedMilestone.push(item.id);
        } else {
          cov_aer4v9vw8.b[65][1]++;
        }
        cov_aer4v9vw8.s[252]++;
        $scope.listMilestone.splice(index, 1);
      } else {
        cov_aer4v9vw8.b[64][1]++;
      }
    });
  };

  cov_aer4v9vw8.s[253]++;
  $CRUDService.save($scope.PATH, { action: 'delete_img_portfolio' });

  cov_aer4v9vw8.s[254]++;
  $scope.isloading = true;
  cov_aer4v9vw8.s[255]++;
  $CRUDService.getAll('DefaultLogFrame', { get: 'all' }, function (data) {
    cov_aer4v9vw8.f[38]++;
    cov_aer4v9vw8.s[256]++;

    if (data) {
      cov_aer4v9vw8.b[66][0]++;
      cov_aer4v9vw8.s[257]++;

      $scope.listOptionSEMethods = data;
      cov_aer4v9vw8.s[258]++;
      $scope.listOptionSEMethods.push({ id: '0', LABEL_LOG_FRAME: $translate.instant('PROJECT.CUSTOM_LOGFRAME') });
    } else {
      cov_aer4v9vw8.b[66][1]++;
    }
    cov_aer4v9vw8.s[259]++;
    $scope.getAll();
  });

  cov_aer4v9vw8.s[260]++;
  $scope.imageUpdated = null;

  var uploader = (cov_aer4v9vw8.s[261]++, $scope.uploader = new FileUploader({
    headers: $CRUDService.getHeader(),
    url: $CRUDService.getServerAdress() + 'web_server.php?action=img_portfolio&method=1&' + $CRUDService.getComplement() + '&li_bksb=Projet',
    alias: 'fileformatrapp',
    removeAfterUpload: true
  }));

  cov_aer4v9vw8.s[262]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_aer4v9vw8.f[39]++;
    cov_aer4v9vw8.s[263]++;

    fileItem.url = uploader.url + '&id=' + $scope.selectedItem.id;
    cov_aer4v9vw8.s[264]++;
    $scope.isloading = true;
    cov_aer4v9vw8.s[265]++;
    fileItem.upload();
  };

  cov_aer4v9vw8.s[266]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_aer4v9vw8.f[40]++;
    cov_aer4v9vw8.s[267]++;

    $scope.imageUpdated = $deltahttp.getProjectRepository(response.f);
    cov_aer4v9vw8.s[268]++;
    $scope.isloading = false;
  };

  cov_aer4v9vw8.s[269]++;
  $CRUDService.getAll('CategoryPersonnaliseA', { get: 'all' }, function (data) {
    cov_aer4v9vw8.f[41]++;
    cov_aer4v9vw8.s[270]++;

    console.log("Structure données : ", data);
    cov_aer4v9vw8.s[271]++;
    $scope.categoryPers_A = data;
  });

  cov_aer4v9vw8.s[272]++;
  $CRUDService.getAll('CategoryPersonnaliseB', { get: 'all' }, function (data) {
    cov_aer4v9vw8.f[42]++;
    cov_aer4v9vw8.s[273]++;

    $scope.categoryPers_B = data;
  });

  cov_aer4v9vw8.s[274]++;
  $scope.updateCatPersA = function (item, deleteItem) {
    cov_aer4v9vw8.f[43]++;
    cov_aer4v9vw8.s[275]++;

    $scope.categoryPers_A = (cov_aer4v9vw8.b[67][0]++, $scope.categoryPers_A) || (cov_aer4v9vw8.b[67][1]++, []);
    cov_aer4v9vw8.s[276]++;
    if (deleteItem) {
      cov_aer4v9vw8.b[68][0]++;
      cov_aer4v9vw8.s[277]++;

      $scope.categoryPers_A = $scope.categoryPers_A.filter(function (categoryPers) {
        cov_aer4v9vw8.f[44]++;
        cov_aer4v9vw8.s[278]++;

        return categoryPers.id != item.id;
      });
      cov_aer4v9vw8.s[279]++;
      return;
    } else {
      cov_aer4v9vw8.b[68][1]++;
    }
    cov_aer4v9vw8.s[280]++;
    for (var _iterator8 = $scope.categoryPers_A, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray8) {
        if (_i8 >= _iterator8.length) break;
        _ref8 = _iterator8[_i8++];
      } else {
        _i8 = _iterator8.next();
        if (_i8.done) break;
        _ref8 = _i8.value;
      }

      var categoryPers = _ref8;
      cov_aer4v9vw8.s[281]++;

      if (categoryPers.id == item.id) {
        cov_aer4v9vw8.b[69][0]++;
        cov_aer4v9vw8.s[282]++;

        categoryPers.NAME = item.NAME;
        cov_aer4v9vw8.s[283]++;
        categoryPers.COLOR = item.COLOR;
        cov_aer4v9vw8.s[284]++;
        return;
      } else {
        cov_aer4v9vw8.b[69][1]++;
      }
    }
    cov_aer4v9vw8.s[285]++;
    $scope.categoryPers_A.push(item);
  };

  cov_aer4v9vw8.s[286]++;
  $scope.updateCatPersB = function (item, deleteItem) {
    cov_aer4v9vw8.f[45]++;
    cov_aer4v9vw8.s[287]++;

    $scope.categoryPers_B = (cov_aer4v9vw8.b[70][0]++, $scope.categoryPers_B) || (cov_aer4v9vw8.b[70][1]++, []);
    cov_aer4v9vw8.s[288]++;
    if (deleteItem) {
      cov_aer4v9vw8.b[71][0]++;
      cov_aer4v9vw8.s[289]++;

      $scope.categoryPers_B = $scope.categoryPers_B.filter(function (categoryPers) {
        cov_aer4v9vw8.f[46]++;
        cov_aer4v9vw8.s[290]++;

        return categoryPers.id != item.id;
      });
      cov_aer4v9vw8.s[291]++;
      return;
    } else {
      cov_aer4v9vw8.b[71][1]++;
    }
    cov_aer4v9vw8.s[292]++;
    for (var _iterator9 = $scope.categoryPers_B, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
      var _ref9;

      if (_isArray9) {
        if (_i9 >= _iterator9.length) break;
        _ref9 = _iterator9[_i9++];
      } else {
        _i9 = _iterator9.next();
        if (_i9.done) break;
        _ref9 = _i9.value;
      }

      var categoryPers = _ref9;
      cov_aer4v9vw8.s[293]++;

      if (categoryPers.id == item.id) {
        cov_aer4v9vw8.b[72][0]++;
        cov_aer4v9vw8.s[294]++;

        categoryPers.NAME = item.NAME;
        cov_aer4v9vw8.s[295]++;
        categoryPers.COLOR = item.COLOR;
        cov_aer4v9vw8.s[296]++;
        return;
      } else {
        cov_aer4v9vw8.b[72][1]++;
      }
    }
    cov_aer4v9vw8.s[297]++;
    $scope.categoryPers_B.push(item);
  };

  cov_aer4v9vw8.s[298]++;

  $scope.openPersonalize_1 = function () {
    cov_aer4v9vw8.f[47]++;
    cov_aer4v9vw8.s[299]++;

    $uibModal.open({
      templateUrl: 'app/views/program/first_customed_category.html',
      controller: Personnalize_1_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_aer4v9vw8.s[300]++;
  $scope.openPersonalize_2 = function () {
    cov_aer4v9vw8.f[48]++;
    cov_aer4v9vw8.s[301]++;

    $uibModal.open({
      templateUrl: 'app/views/program/second_customed_category.html',
      controller: Personnalize_2_Ctrl_Project_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };
});
function Personnalize_1_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_aer4v9vw8.f[49]++;
  cov_aer4v9vw8.s[302]++;

  $scope.addCategory = function () {
    cov_aer4v9vw8.f[50]++;
    cov_aer4v9vw8.s[303]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_aer4v9vw8.s[304]++;
  $scope.editCategory = function (item) {
    cov_aer4v9vw8.f[51]++;
    cov_aer4v9vw8.s[305]++;

    $scope.error_code = {};
    cov_aer4v9vw8.s[306]++;
    $scope.selectedCatPersA = angular.copy(item);
  };

  cov_aer4v9vw8.s[307]++;
  $scope.cancelCategory = function () {
    cov_aer4v9vw8.f[52]++;
    cov_aer4v9vw8.s[308]++;

    $scope.selectedCatPersA = null;
  };

  cov_aer4v9vw8.s[309]++;
  $scope.validateCategory = function () {
    cov_aer4v9vw8.f[53]++;
    cov_aer4v9vw8.s[310]++;

    $scope.error_code = {};
    cov_aer4v9vw8.s[311]++;
    $scope.categoryPers_A = [];
    cov_aer4v9vw8.s[312]++;

    if ((cov_aer4v9vw8.b[74][0]++, !$scope.categoryPers_A) || (cov_aer4v9vw8.b[74][1]++, !Array.isArray($scope.categoryPers_A))) {
      cov_aer4v9vw8.b[73][0]++;
      cov_aer4v9vw8.s[313]++;

      console.warn('categoryPers_A n\'est pas un tableau valide:', $scope.categoryPers_A);
      cov_aer4v9vw8.s[314]++;

      $scope.categoryPers_A = [];
    } else {
      cov_aer4v9vw8.b[73][1]++;
    }

    cov_aer4v9vw8.s[315]++;

    if ((cov_aer4v9vw8.b[76][0]++, !$scope.selectedCatPersA) || (cov_aer4v9vw8.b[76][1]++, !$scope.selectedCatPersA.NAME)) {
      cov_aer4v9vw8.b[75][0]++;
      cov_aer4v9vw8.s[316]++;

      $scope.error_code.name = true;
      cov_aer4v9vw8.s[317]++;
      return;
    } else {
      cov_aer4v9vw8.b[75][1]++;
    }

    cov_aer4v9vw8.s[318]++;

    if ($scope.categoryPers_A.filter(function (category) {
      cov_aer4v9vw8.f[54]++;
      cov_aer4v9vw8.s[319]++;

      return (cov_aer4v9vw8.b[78][0]++, $scope.selectedCatPersA.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_aer4v9vw8.b[78][1]++, category.id != $scope.selectedCatPersA.id);
    }).length > 0) {
      cov_aer4v9vw8.b[77][0]++;
      cov_aer4v9vw8.s[320]++;

      $scope.error_code.name = true;
      cov_aer4v9vw8.s[321]++;
      return;
    } else {
      cov_aer4v9vw8.b[77][1]++;
    }

    cov_aer4v9vw8.s[322]++;
    $CRUDService.save('CategoryPersonnaliseA', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersA)
    }, function (data) {
      cov_aer4v9vw8.f[55]++;
      cov_aer4v9vw8.s[323]++;

      $scope.selectedCatPersA.id = String(parseInt(data, 10));
      cov_aer4v9vw8.s[324]++;
      $scope.updateCatPersA(angular.copy($scope.selectedCatPersA));
      cov_aer4v9vw8.s[325]++;
      $scope.selectedCatPersA = null;
    });
  };

  cov_aer4v9vw8.s[326]++;
  $scope.deleteCategory = function (item) {
    cov_aer4v9vw8.f[56]++;
    cov_aer4v9vw8.s[327]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_aer4v9vw8.f[57]++;
      cov_aer4v9vw8.s[328]++;

      if (isconfirm) {
        cov_aer4v9vw8.b[79][0]++;
        cov_aer4v9vw8.s[329]++;

        return;
      } else {
        cov_aer4v9vw8.b[79][1]++;
      }
      cov_aer4v9vw8.s[330]++;
      $scope.isloading = true;
      var validateItem = (cov_aer4v9vw8.s[331]++, {
        id: item.id
      });
      cov_aer4v9vw8.s[332]++;
      $CRUDService.delet('CategoryPersonnaliseA', { action: 'supp', id: item.id }, function (data) {
        cov_aer4v9vw8.f[58]++;
        cov_aer4v9vw8.s[333]++;

        if (data < 0) {
          cov_aer4v9vw8.b[80][0]++;
          cov_aer4v9vw8.s[334]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_aer4v9vw8.s[335]++;
          $scope.isloading = false;
          cov_aer4v9vw8.s[336]++;
          return;
        } else {
          cov_aer4v9vw8.b[80][1]++;
        }
        cov_aer4v9vw8.s[337]++;
        $scope.updateCatPersA({ id: validateItem.id }, true);
      });
    });
  };

  cov_aer4v9vw8.s[338]++;
  $scope.closeModal = function () {
    cov_aer4v9vw8.f[59]++;
    cov_aer4v9vw8.s[339]++;

    $uibModalInstance.dismiss('cancel');
  };
}

function Personnalize_2_Ctrl_Project_edit($scope, $uibModalInstance, $filter, $CRUDService, SweetAlert, $translate) {
  cov_aer4v9vw8.f[60]++;
  cov_aer4v9vw8.s[340]++;

  $scope.addCategory = function () {
    cov_aer4v9vw8.f[61]++;
    cov_aer4v9vw8.s[341]++;

    $scope.editCategory({
      id: 0,
      NAME: ''
    });
  };

  cov_aer4v9vw8.s[342]++;
  $scope.editCategory = function (item) {
    cov_aer4v9vw8.f[62]++;
    cov_aer4v9vw8.s[343]++;

    $scope.error_code = {};
    cov_aer4v9vw8.s[344]++;
    $scope.selectedCatPersB = angular.copy(item);
  };

  cov_aer4v9vw8.s[345]++;
  $scope.cancelCategory = function () {
    cov_aer4v9vw8.f[63]++;
    cov_aer4v9vw8.s[346]++;

    $scope.selectedCatPersB = null;
  };

  cov_aer4v9vw8.s[347]++;
  $scope.validateCategory = function () {
    cov_aer4v9vw8.f[64]++;
    cov_aer4v9vw8.s[348]++;

    $scope.error_code = {};

    cov_aer4v9vw8.s[349]++;

    if ((cov_aer4v9vw8.b[82][0]++, !$scope.categoryPers_B) || (cov_aer4v9vw8.b[82][1]++, !Array.isArray($scope.categoryPers_B))) {
      cov_aer4v9vw8.b[81][0]++;
      cov_aer4v9vw8.s[350]++;

      console.warn('categoryPers_B n\'est pas un tableau valide:', $scope.categoryPers_B);
      cov_aer4v9vw8.s[351]++;

      $scope.categoryPers_B = [];
    } else {
      cov_aer4v9vw8.b[81][1]++;
    }

    cov_aer4v9vw8.s[352]++;

    if ((cov_aer4v9vw8.b[84][0]++, !$scope.selectedCatPersB) || (cov_aer4v9vw8.b[84][1]++, !$scope.selectedCatPersB.NAME)) {
      cov_aer4v9vw8.b[83][0]++;
      cov_aer4v9vw8.s[353]++;

      $scope.error_code.name = true;
      cov_aer4v9vw8.s[354]++;
      return;
    } else {
      cov_aer4v9vw8.b[83][1]++;
    }

    cov_aer4v9vw8.s[355]++;

    if ($scope.categoryPers_B.filter(function (category) {
      cov_aer4v9vw8.f[65]++;
      cov_aer4v9vw8.s[356]++;

      return (cov_aer4v9vw8.b[86][0]++, $scope.selectedCatPersB.NAME.toUpperCase() === category.NAME.toUpperCase()) && (cov_aer4v9vw8.b[86][1]++, category.id != $scope.selectedCatPersB.id);
    }).length > 0) {
      cov_aer4v9vw8.b[85][0]++;
      cov_aer4v9vw8.s[357]++;

      $scope.error_code.name = true;
      cov_aer4v9vw8.s[358]++;
      return;
    } else {
      cov_aer4v9vw8.b[85][1]++;
    }

    cov_aer4v9vw8.s[359]++;
    $CRUDService.save('CategoryPersonnaliseB', {
      action: 'MiseAJour',
      valeur: $filter('json')($scope.selectedCatPersB)
    }, function (data) {
      cov_aer4v9vw8.f[66]++;
      cov_aer4v9vw8.s[360]++;

      $scope.selectedCatPersB.id = String(parseInt(data, 10));
      cov_aer4v9vw8.s[361]++;
      $scope.updateCatPersB(angular.copy($scope.selectedCatPersB));
      cov_aer4v9vw8.s[362]++;
      $scope.selectedCatPersB = null;
    });
  };

  cov_aer4v9vw8.s[363]++;
  $scope.deleteCategory = function (item) {
    cov_aer4v9vw8.f[67]++;
    cov_aer4v9vw8.s[364]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_aer4v9vw8.f[68]++;
      cov_aer4v9vw8.s[365]++;

      if (isconfirm) {
        cov_aer4v9vw8.b[87][0]++;
        cov_aer4v9vw8.s[366]++;

        return;
      } else {
        cov_aer4v9vw8.b[87][1]++;
      }
      cov_aer4v9vw8.s[367]++;
      $scope.isloading = true;
      var validateItem = (cov_aer4v9vw8.s[368]++, {
        id: item.id
      });
      cov_aer4v9vw8.s[369]++;
      $CRUDService.delet('CategoryPersonnaliseB', { action: 'supp', id: item.id }, function (data) {
        cov_aer4v9vw8.f[69]++;
        cov_aer4v9vw8.s[370]++;

        if (data < 0) {
          cov_aer4v9vw8.b[88][0]++;
          cov_aer4v9vw8.s[371]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('PORTFOLIO.ERROR.DELETE')
          });
          cov_aer4v9vw8.s[372]++;
          $scope.isloading = false;
          cov_aer4v9vw8.s[373]++;
          return;
        } else {
          cov_aer4v9vw8.b[88][1]++;
        }
        cov_aer4v9vw8.s[374]++;
        $scope.updateCatPersB({ id: validateItem.id }, true);
      });
    });
  };

  cov_aer4v9vw8.s[375]++;
  $scope.closeModal = function () {
    cov_aer4v9vw8.f[70]++;
    cov_aer4v9vw8.s[376]++;

    $uibModalInstance.dismiss('cancel');
  };
}